function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

/**
 * Do not edit this file directly
 * Generated by the Style Dictionary Builder.
 */
var borderRadiusPill = '9999px';
var borderRadiusCircle = '100%';
var borderRadiusNone = '0px';
var borderRadiusSm = '4px';
var borderRadiusMd = '8px';
var borderRadiusLg = '16px';
var borderRadiusXl = '24px';
var borderRadiusSemiSquare = '2px'; // 2px / 2.00

var borderRadiusRounded = '4px'; // 4px / 4.00

var border = {
  __proto__: null,
  borderRadiusPill: borderRadiusPill,
  borderRadiusCircle: borderRadiusCircle,
  borderRadiusNone: borderRadiusNone,
  borderRadiusSm: borderRadiusSm,
  borderRadiusMd: borderRadiusMd,
  borderRadiusLg: borderRadiusLg,
  borderRadiusXl: borderRadiusXl,
  borderRadiusSemiSquare: borderRadiusSemiSquare,
  borderRadiusRounded: borderRadiusRounded
};

/**
 * Do not edit this file directly
 * Generated by the Style Dictionary Builder.
 */
var breakpointSmMinWidth = '320px'; // Mobile

var breakpointSmMaxWidth = '767px';
var breakpointMdMinWidth = '768px'; // Tablet

var breakpointMdMaxWidth = '1139px';
var breakpointLgMinWidth = '1140px'; // Laptop

var breakpointLgMaxWidth = '1365px';
var breakpointXlMinWidth = '1366px'; // Desktop

var breakpoint = {
  __proto__: null,
  breakpointSmMinWidth: breakpointSmMinWidth,
  breakpointSmMaxWidth: breakpointSmMaxWidth,
  breakpointMdMinWidth: breakpointMdMinWidth,
  breakpointMdMaxWidth: breakpointMdMaxWidth,
  breakpointLgMinWidth: breakpointLgMinWidth,
  breakpointLgMaxWidth: breakpointLgMaxWidth,
  breakpointXlMinWidth: breakpointXlMinWidth
};

/**
 * Do not edit this file directly
 * Generated by the Style Dictionary Builder.
 */
var colorReferenceBrand016 = '#4B070C';
var colorReferenceBrand024 = '#7A001A';
var colorReferenceBrand032 = '#A30023';
var colorReferenceBrand040 = '#C01D31'; // Former color.brand.low

var colorReferenceBrand048 = '#EB0033';
var colorReferenceBrand056 = '#E83F53';
var colorReferenceBrand064 = '#FA5266';
var colorReferenceBrand072 = '#F37C84';
var colorReferenceBrand080 = '#FF99AF';
var colorReferenceBrand088 = '#FFC2CF';
var colorReferenceBrand096 = '#FFEBEF';
var colorReferenceInformative016 = '#122140';
var colorReferenceInformative024 = '#1B325F';
var colorReferenceInformative032 = '#24427F';
var colorReferenceInformative040 = '#2D539F';
var colorReferenceInformative048 = '#3664BF';
var colorReferenceInformative056 = '#507ACE';
var colorReferenceInformative064 = '#7092D7';
var colorReferenceInformative072 = '#90AAE0';
var colorReferenceInformative080 = '#AFC2E9'; // Former color.informative.medium

var colorReferenceInformative088 = '#CFDBF2';
var colorReferenceInformative096 = '#EFF3FB';
var colorReferenceSuccess016 = '#19392C';
var colorReferenceSuccess024 = '#255542';
var colorReferenceSuccess032 = '#327258';
var colorReferenceSuccess040 = '#3E8E6E';
var colorReferenceSuccess048 = '#4AAA85';
var colorReferenceSuccess056 = '#63BB98';
var colorReferenceSuccess064 = '#7FC7AB';
var colorReferenceSuccess072 = '#9CD4BE';
var colorReferenceSuccess080 = '#B8E0D0';
var colorReferenceSuccess088 = '#D4ECE3';
var colorReferenceSuccess096 = '#F1F9F6';
var colorReferenceCritical016 = '#4B070C';
var colorReferenceCritical024 = '#700A11';
var colorReferenceCritical032 = '#950E18';
var colorReferenceCritical040 = '#BB111C'; // Former color.brand.low

var colorReferenceCritical048 = '#E01524';
var colorReferenceCritical056 = '#EC323F';
var colorReferenceCritical064 = '#EF5762';
var colorReferenceCritical072 = '#F37C84';
var colorReferenceCritical080 = '#F6A2A8';
var colorReferenceCritical088 = '#FAC7CB';
var colorReferenceCritical096 = '#FDECEE';
var colorReferenceAttention016 = '#4D3504';
var colorReferenceAttention024 = '#744F07';
var colorReferenceAttention032 = '#9A6A09';
var colorReferenceAttention040 = '#C1840B';
var colorReferenceAttention048 = '#E79F0D';
var colorReferenceAttention056 = '#F3B02B';
var colorReferenceAttention064 = '#F5BE51';
var colorReferenceAttention072 = '#F7CD78';
var colorReferenceAttention080 = '#F9DB9F';
var colorReferenceAttention088 = '#FCE9C5';
var colorReferenceAttention096 = '#FEF8EC';
var colorReferenceNeutral100 = '#FFFFFF'; // Former color.neutralLight.pure

var colorReferenceNeutral008 = '#141414';
var colorReferenceNeutral016 = '#292929';
var colorReferenceNeutral024 = '#3D3D3D';
var colorReferenceNeutral032 = '#525252';
var colorReferenceNeutral040 = '#666666';
var colorReferenceNeutral048 = '#7A7A7A';
var colorReferenceNeutral056 = '#8F8F8F';
var colorReferenceNeutral064 = '#A3A3A3';
var colorReferenceNeutral072 = '#B8B8B8';
var colorReferenceNeutral080 = '#CCCCCC'; // Former color.neutralLight.medium

var colorReferenceNeutral088 = '#E0E0E0';
var colorReferenceNeutral096 = '#F5F5F5';
var colorReferenceCraftSecondary016 = '#421033';
var colorReferenceCraftSecondary024 = '#63174D';
var colorReferenceCraftSecondary032 = '#841F67';
var colorReferenceCraftSecondary040 = '#A52781';
var colorReferenceCraftSecondary048 = '#C62F9A';
var colorReferenceCraftSecondary056 = '#D449AC';
var colorReferenceCraftSecondary064 = '#DC6ABB';
var colorReferenceCraftSecondary072 = '#ECACD9';
var colorReferenceCraftSecondary080 = '#ECACD9';
var colorReferenceCraftSecondary088 = '#F3CDE8';
var colorReferenceCraftSecondary096 = '#FBEEF7';
var colorReferenceCraftTertiary016 = '#493408';
var colorReferenceCraftTertiary024 = '#6E4E0C';
var colorReferenceCraftTertiary032 = '#936710';
var colorReferenceCraftTertiary040 = '#B88114';
var colorReferenceCraftTertiary048 = '#DC9B18';
var colorReferenceCraftTertiary056 = '#E9AD35';
var colorReferenceCraftTertiary064 = '#EDBC5A';
var colorReferenceCraftTertiary072 = '#F1CB7E';
var colorReferenceCraftTertiary080 = '#F5DAA3';
var colorReferenceCraftTertiary088 = '#F9E9C8';
var colorReferenceCraftTertiary096 = '#FDF8ED';
var colorRoleBrand = '#FA5266';
var colorRoleOnBrand = '#141414';
var colorRoleBrandSecondary = '#7A001A';
var colorRoleOnBrandSecondary = '#F5F5F5';
var colorRoleInformative = '#7092D7';
var colorRoleOnInformative = '#141414';
var colorRoleInformativeSecondary = '#1B325F';
var colorRoleOnInformativeSecondary = '#EFF3FB';
var colorRoleSuccess = '#B8E0D0';
var colorRoleOnSuccess = '#141414';
var colorRoleSuccessSecondary = '#255542';
var colorRoleOnSuccessSecondary = '#F1F9F6';
var colorRoleCritical = '#EF5762';
var colorRoleOnCritical = '#141414';
var colorRoleCriticalSecondary = '#700A11';
var colorRoleOnCriticalSecondary = '#FDECEE';
var colorRoleAttention = '#C1840B';
var colorRoleOnAttention = '#FFFFFF';
var colorRoleAttentionSecondary = '#744F07';
var colorRoleOnAttentionSecondary = '#FEF8EC';
var colorRoleBackground = '#141414';
var colorRoleOnBackground = '#FFFFFF';
var colorRoleBackgroundInverse = '#FFFFFF';
var colorRoleOnBackgroundInverse = '#141414';
var colorRoleBackgroundSecondary = '#292929';
var colorRoleOnBackgroundSecondary = '#FFFFFF';
var colorRoleBackgroundSecondaryInverse = '#F5F5F5';
var colorRoleOnBackgroundSecondaryInverse = '#141414';
var colorRoleSurface = '#141414';
var colorRoleSurfaceInverse = '#FFFFFF';
var colorRoleOnSurface = '#FFFFFF';
var colorRoleOnSurfaceInverse = '#141414';
var colorRoleSurfaceSecondary = '#4B070C';
var colorRoleOnSurfaceSecondary = '#FFFFFF';
var colorRoleSurfaceSecondaryInverse = '#FFEBEF';
var colorRoleOnSurfaceSecondaryInverse = '#141414';
var colorRoleOutline = '#525252';
var colorRoleOutlineFocus = '#FFFFFF';
var colorRoleHeading = '#FFFFFF';
var colorRoleHeadingInverse = '#141414';
var colorRoleBody = '#CCCCCC';
var colorRoleBodyInverse = '#525252';
var colorRoleBodySecondary = '#A3A3A3';
var colorRoleBodySecondaryInverse = '#7A7A7A';
var colorRoleHyperlink = '#FFFFFF';

var darkThemeColor = {
  __proto__: null,
  colorReferenceBrand016: colorReferenceBrand016,
  colorReferenceBrand024: colorReferenceBrand024,
  colorReferenceBrand032: colorReferenceBrand032,
  colorReferenceBrand040: colorReferenceBrand040,
  colorReferenceBrand048: colorReferenceBrand048,
  colorReferenceBrand056: colorReferenceBrand056,
  colorReferenceBrand064: colorReferenceBrand064,
  colorReferenceBrand072: colorReferenceBrand072,
  colorReferenceBrand080: colorReferenceBrand080,
  colorReferenceBrand088: colorReferenceBrand088,
  colorReferenceBrand096: colorReferenceBrand096,
  colorReferenceInformative016: colorReferenceInformative016,
  colorReferenceInformative024: colorReferenceInformative024,
  colorReferenceInformative032: colorReferenceInformative032,
  colorReferenceInformative040: colorReferenceInformative040,
  colorReferenceInformative048: colorReferenceInformative048,
  colorReferenceInformative056: colorReferenceInformative056,
  colorReferenceInformative064: colorReferenceInformative064,
  colorReferenceInformative072: colorReferenceInformative072,
  colorReferenceInformative080: colorReferenceInformative080,
  colorReferenceInformative088: colorReferenceInformative088,
  colorReferenceInformative096: colorReferenceInformative096,
  colorReferenceSuccess016: colorReferenceSuccess016,
  colorReferenceSuccess024: colorReferenceSuccess024,
  colorReferenceSuccess032: colorReferenceSuccess032,
  colorReferenceSuccess040: colorReferenceSuccess040,
  colorReferenceSuccess048: colorReferenceSuccess048,
  colorReferenceSuccess056: colorReferenceSuccess056,
  colorReferenceSuccess064: colorReferenceSuccess064,
  colorReferenceSuccess072: colorReferenceSuccess072,
  colorReferenceSuccess080: colorReferenceSuccess080,
  colorReferenceSuccess088: colorReferenceSuccess088,
  colorReferenceSuccess096: colorReferenceSuccess096,
  colorReferenceCritical016: colorReferenceCritical016,
  colorReferenceCritical024: colorReferenceCritical024,
  colorReferenceCritical032: colorReferenceCritical032,
  colorReferenceCritical040: colorReferenceCritical040,
  colorReferenceCritical048: colorReferenceCritical048,
  colorReferenceCritical056: colorReferenceCritical056,
  colorReferenceCritical064: colorReferenceCritical064,
  colorReferenceCritical072: colorReferenceCritical072,
  colorReferenceCritical080: colorReferenceCritical080,
  colorReferenceCritical088: colorReferenceCritical088,
  colorReferenceCritical096: colorReferenceCritical096,
  colorReferenceAttention016: colorReferenceAttention016,
  colorReferenceAttention024: colorReferenceAttention024,
  colorReferenceAttention032: colorReferenceAttention032,
  colorReferenceAttention040: colorReferenceAttention040,
  colorReferenceAttention048: colorReferenceAttention048,
  colorReferenceAttention056: colorReferenceAttention056,
  colorReferenceAttention064: colorReferenceAttention064,
  colorReferenceAttention072: colorReferenceAttention072,
  colorReferenceAttention080: colorReferenceAttention080,
  colorReferenceAttention088: colorReferenceAttention088,
  colorReferenceAttention096: colorReferenceAttention096,
  colorReferenceNeutral100: colorReferenceNeutral100,
  colorReferenceNeutral008: colorReferenceNeutral008,
  colorReferenceNeutral016: colorReferenceNeutral016,
  colorReferenceNeutral024: colorReferenceNeutral024,
  colorReferenceNeutral032: colorReferenceNeutral032,
  colorReferenceNeutral040: colorReferenceNeutral040,
  colorReferenceNeutral048: colorReferenceNeutral048,
  colorReferenceNeutral056: colorReferenceNeutral056,
  colorReferenceNeutral064: colorReferenceNeutral064,
  colorReferenceNeutral072: colorReferenceNeutral072,
  colorReferenceNeutral080: colorReferenceNeutral080,
  colorReferenceNeutral088: colorReferenceNeutral088,
  colorReferenceNeutral096: colorReferenceNeutral096,
  colorReferenceCraftSecondary016: colorReferenceCraftSecondary016,
  colorReferenceCraftSecondary024: colorReferenceCraftSecondary024,
  colorReferenceCraftSecondary032: colorReferenceCraftSecondary032,
  colorReferenceCraftSecondary040: colorReferenceCraftSecondary040,
  colorReferenceCraftSecondary048: colorReferenceCraftSecondary048,
  colorReferenceCraftSecondary056: colorReferenceCraftSecondary056,
  colorReferenceCraftSecondary064: colorReferenceCraftSecondary064,
  colorReferenceCraftSecondary072: colorReferenceCraftSecondary072,
  colorReferenceCraftSecondary080: colorReferenceCraftSecondary080,
  colorReferenceCraftSecondary088: colorReferenceCraftSecondary088,
  colorReferenceCraftSecondary096: colorReferenceCraftSecondary096,
  colorReferenceCraftTertiary016: colorReferenceCraftTertiary016,
  colorReferenceCraftTertiary024: colorReferenceCraftTertiary024,
  colorReferenceCraftTertiary032: colorReferenceCraftTertiary032,
  colorReferenceCraftTertiary040: colorReferenceCraftTertiary040,
  colorReferenceCraftTertiary048: colorReferenceCraftTertiary048,
  colorReferenceCraftTertiary056: colorReferenceCraftTertiary056,
  colorReferenceCraftTertiary064: colorReferenceCraftTertiary064,
  colorReferenceCraftTertiary072: colorReferenceCraftTertiary072,
  colorReferenceCraftTertiary080: colorReferenceCraftTertiary080,
  colorReferenceCraftTertiary088: colorReferenceCraftTertiary088,
  colorReferenceCraftTertiary096: colorReferenceCraftTertiary096,
  colorRoleBrand: colorRoleBrand,
  colorRoleOnBrand: colorRoleOnBrand,
  colorRoleBrandSecondary: colorRoleBrandSecondary,
  colorRoleOnBrandSecondary: colorRoleOnBrandSecondary,
  colorRoleInformative: colorRoleInformative,
  colorRoleOnInformative: colorRoleOnInformative,
  colorRoleInformativeSecondary: colorRoleInformativeSecondary,
  colorRoleOnInformativeSecondary: colorRoleOnInformativeSecondary,
  colorRoleSuccess: colorRoleSuccess,
  colorRoleOnSuccess: colorRoleOnSuccess,
  colorRoleSuccessSecondary: colorRoleSuccessSecondary,
  colorRoleOnSuccessSecondary: colorRoleOnSuccessSecondary,
  colorRoleCritical: colorRoleCritical,
  colorRoleOnCritical: colorRoleOnCritical,
  colorRoleCriticalSecondary: colorRoleCriticalSecondary,
  colorRoleOnCriticalSecondary: colorRoleOnCriticalSecondary,
  colorRoleAttention: colorRoleAttention,
  colorRoleOnAttention: colorRoleOnAttention,
  colorRoleAttentionSecondary: colorRoleAttentionSecondary,
  colorRoleOnAttentionSecondary: colorRoleOnAttentionSecondary,
  colorRoleBackground: colorRoleBackground,
  colorRoleOnBackground: colorRoleOnBackground,
  colorRoleBackgroundInverse: colorRoleBackgroundInverse,
  colorRoleOnBackgroundInverse: colorRoleOnBackgroundInverse,
  colorRoleBackgroundSecondary: colorRoleBackgroundSecondary,
  colorRoleOnBackgroundSecondary: colorRoleOnBackgroundSecondary,
  colorRoleBackgroundSecondaryInverse: colorRoleBackgroundSecondaryInverse,
  colorRoleOnBackgroundSecondaryInverse: colorRoleOnBackgroundSecondaryInverse,
  colorRoleSurface: colorRoleSurface,
  colorRoleSurfaceInverse: colorRoleSurfaceInverse,
  colorRoleOnSurface: colorRoleOnSurface,
  colorRoleOnSurfaceInverse: colorRoleOnSurfaceInverse,
  colorRoleSurfaceSecondary: colorRoleSurfaceSecondary,
  colorRoleOnSurfaceSecondary: colorRoleOnSurfaceSecondary,
  colorRoleSurfaceSecondaryInverse: colorRoleSurfaceSecondaryInverse,
  colorRoleOnSurfaceSecondaryInverse: colorRoleOnSurfaceSecondaryInverse,
  colorRoleOutline: colorRoleOutline,
  colorRoleOutlineFocus: colorRoleOutlineFocus,
  colorRoleHeading: colorRoleHeading,
  colorRoleHeadingInverse: colorRoleHeadingInverse,
  colorRoleBody: colorRoleBody,
  colorRoleBodyInverse: colorRoleBodyInverse,
  colorRoleBodySecondary: colorRoleBodySecondary,
  colorRoleBodySecondaryInverse: colorRoleBodySecondaryInverse,
  colorRoleHyperlink: colorRoleHyperlink
};

/**
 * Do not edit this file directly
 * Generated by the Style Dictionary Builder.
 */
var component = {
  badge: {
    root: {
      fontFamily: '"iFood RC Textos", Helvetica, Arial, sans-serif',
      fontWeight: '700',
      lineHeight: '16px',
      maxWidth: '200px',
      transitionDelay: '0ms',
      transitionDuration: '100ms',
      transitionTimingFunction: 'ease-in-out'
    },
    sm: {
      fontSize: '10px',
      height: '16px',
      minWidth: '16px',
      padding: '0px'
    },
    md: {
      fontSize: '12px',
      height: '24px',
      minWidth: '24px',
      padding: '4px'
    },
    standard: {
      backgroundColor: '#3D3D3D',
      color: '#FFFFFF'
    },
    active: {
      backgroundColor: '#E0E0E0',
      color: '#141414'
    },
    success: {
      backgroundColor: '#B8E0D0',
      color: '#141414'
    },
    attention: {
      backgroundColor: '#C1840B',
      color: '#FFFFFF'
    },
    critical: {
      backgroundColor: '#EF5762',
      color: '#141414'
    },
    informative: {
      backgroundColor: '#7092D7',
      color: '#141414'
    },
    disabled: {
      backgroundColor: '#B8B8B8',
      color: '#A3A3A3'
    },
    pill: {
      borderRadius: '9999px'
    },
    semiSquare: {
      borderRadius: '2px'
    }
  },
  breadcrumbs: {
    root: {
      minHeight: '24px',
      minWidth: '120px'
    },
    list: {
      columnGap: '4px',
      margin: '0px',
      padding: '0px'
    }
  },
  button: {
    root: {
      borderWidth: '0px',
      boxShadow: '0px 0px 0px 0px rgba(0, 0, 0, 0.16)',
      fontSize: '16px',
      fontWeight: '700',
      lineHeight: '24px',
      minHeight: '40px',
      minWidth: '48px',
      transitionDelay: '0ms',
      transitionDuration: '100ms',
      transitionTimingFunction: 'ease-in-out',
      zIndex: '0'
    },
    rootBefore: {
      zIndex: '0'
    },
    rootAfter: {
      zIndex: '10'
    },
    content: {
      columnGap: '8px',
      lineHeight: '24px',
      minHeight: '24px',
      minWidth: '24px',
      zIndex: '50'
    },
    gutters: {
      paddingLeft: '24px',
      paddingRight: '24px'
    },
    primary: {
      boxShadow: '0px 0px 0px 0px rgba(0, 0, 0, 0.16)',
      color: '#141414'
    },
    primaryBefore: {
      backgroundColor: '#FFFFFF'
    },
    primaryDisabled: {
      boxShadow: '0px 0px 0px 0px rgba(0, 0, 0, 0.16)',
      color: '#7A7A7A'
    },
    primaryDisabledBefore: {
      backgroundColor: '#B8B8B8'
    },
    primaryFocused: {
      boxShadow: '0px 0px 0px 0px rgba(0, 0, 0, 0.16)',
      color: '#141414'
    },
    primaryFocusedBefore: {
      backgroundColor: '#E0E0E0'
    },
    primaryFocusedAfter: {
      backgroundColor: '#E0E0E0',
      opacity: '0'
    },
    primaryHover: {
      boxShadow: '0px 2px 8px 0px rgba(0, 0, 0, 0.16)',
      color: '#141414'
    },
    primaryHoverBefore: {
      backgroundColor: '#E0E0E0'
    },
    primaryHoverAfter: {
      backgroundColor: '#E0E0E0',
      opacity: '0'
    },
    primaryPressed: {
      boxShadow: '0px 0px 0px 0px rgba(0, 0, 0, 0.16)',
      color: '#141414'
    },
    primaryPressedBefore: {
      backgroundColor: '#F5F5F5'
    },
    primaryPressedAfter: {
      backgroundColor: 'rgba(245, 245, 245, 0.08)'
    },
    secondary: {
      boxShadow: '0px 0px 0px 0px rgba(0, 0, 0, 0.16)',
      color: '#FFFFFF'
    },
    secondaryBefore: {
      backgroundColor: '#292929'
    },
    secondaryDisabled: {
      boxShadow: '0px 0px 0px 0px rgba(0, 0, 0, 0.16)',
      color: '#A3A3A3'
    },
    secondaryDisabledBefore: {
      backgroundColor: '#B8B8B8'
    },
    secondaryFocused: {
      boxShadow: '0px 0px 0px 0px rgba(0, 0, 0, 0.16)',
      color: '#FFFFFF'
    },
    secondaryFocusedBefore: {
      backgroundColor: '#3D3D3D'
    },
    secondaryFocusedAfter: {
      backgroundColor: '#3D3D3D',
      opacity: '0'
    },
    secondaryHover: {
      boxShadow: '0px 2px 8px 0px rgba(0, 0, 0, 0.16)',
      color: '#FFFFFF'
    },
    secondaryHoverBefore: {
      backgroundColor: '#3D3D3D'
    },
    secondaryHoverAfter: {
      backgroundColor: '#3D3D3D',
      opacity: '0'
    },
    secondaryPressed: {
      boxShadow: '0px 0px 0px 0px rgba(0, 0, 0, 0.16)',
      color: '#FFFFFF'
    },
    secondaryPressedBefore: {
      backgroundColor: '#525252'
    },
    secondaryPressedAfter: {
      backgroundColor: '#525252',
      opacity: '0'
    },
    tertiary: {
      boxShadow: '0px 0px 0px 0px rgba(0, 0, 0, 0.16)',
      color: '#FFFFFF'
    },
    tertiaryBefore: {
      backgroundColor: 'rgba(0, 0, 0, 0)'
    },
    tertiaryDisabled: {
      boxShadow: '0px 0px 0px 0px rgba(0, 0, 0, 0.16)',
      color: '#A3A3A3'
    },
    tertiaryDisabledBefore: {
      backgroundColor: '#B8B8B8'
    },
    tertiaryFocused: {
      boxShadow: '0px 0px 0px 0px rgba(0, 0, 0, 0.16)',
      color: '#FFFFFF'
    },
    tertiaryFocusedBefore: {
      backgroundColor: '#292929'
    },
    tertiaryFocusedAfter: {
      backgroundColor: 'rgba(224, 224, 224, 0.08)'
    },
    tertiaryHover: {
      boxShadow: '0px 2px 8px 0px rgba(0, 0, 0, 0.16)',
      color: '#FFFFFF'
    },
    tertiaryHoverBefore: {
      backgroundColor: '#292929'
    },
    tertiaryHoverAfter: {
      backgroundColor: 'rgba(224, 224, 224, 0.08)'
    },
    tertiaryPressed: {
      boxShadow: '0px 0px 0px 0px rgba(0, 0, 0, 0.16)',
      color: '#FFFFFF'
    },
    tertiaryPressedBefore: {
      backgroundColor: '#3D3D3D'
    },
    tertiaryPressedAfter: {
      backgroundColor: 'rgba(224, 224, 224, 0.08)'
    },
    pill: {
      borderRadius: '9999px'
    },
    rounded: {
      borderRadius: '4px'
    },
    xs: {
      height: '32px'
    },
    sm: {
      height: '40px',
      paddingBottom: '8px',
      paddingTop: '8px'
    },
    md: {
      height: '48px',
      paddingBottom: '12px',
      paddingTop: '12px'
    },
    lg: {
      height: '56px',
      paddingBottom: '16px',
      paddingTop: '16px'
    },
    withStartIcon: {
      paddingLeft: '16px'
    }
  },
  buttonBase: {
    root: {
      borderRadius: '0px',
      borderWidth: '0px',
      fontFamily: '"iFood RC Textos", Helvetica, Arial, sans-serif',
      marginBottom: '0px',
      marginLeft: '0px',
      marginRight: '0px',
      marginTop: '0px',
      paddingBottom: '0px',
      paddingLeft: '0px',
      paddingRight: '0px',
      paddingTop: '0px',
      outlineColor: '#FFFFFF',
      outlineOffset: '0px',
      outlineWidth: '0px'
    },
    focusVisible: {
      outlineOffset: '2px',
      outlineWidth: '2px'
    }
  },
  buttonGroup: {
    spacingNone: {
      columnGap: '0px'
    },
    spacingXs: {
      columnGap: '20px'
    },
    spacingSm: {
      columnGap: '24px'
    }
  },
  calendar: {
    root: {
      backgroundColor: '#141414',
      borderColor: '#525252',
      borderRadius: '8px',
      borderWidth: '1px',
      color: '#FFFFFF',
      fontFamily: '"iFood RC Textos", Helvetica, Arial, sans-serif',
      fontSize: '16px',
      fontWeight: '500',
      lineHeight: '24px',
      top: '80px',
      zIndex: '10'
    },
    header: {
      backgroundColor: '#141414',
      color: '#FFFFFF',
      fontFamily: '"iFood RC Textos", Helvetica, Arial, sans-serif',
      fontSize: '16px',
      fontWeight: '500',
      lineHeight: '24px',
      paddingTop: '16px',
      paddingRight: '24px',
      paddingBottom: '16px',
      paddingLeft: '24px'
    },
    weekdays: {
      marginBottom: '8px'
    },
    cell: {
      backgroundColor: '#141414',
      color: '#FFFFFF',
      fontFamily: '"iFood RC Textos", Helvetica, Arial, sans-serif',
      fontSize: '16px',
      fontWeight: '400',
      gap: '8px',
      height: '24px',
      lineHeight: '24px',
      transitionDuration: '100ms',
      transitionTimingFunction: 'ease-in-out',
      width: '24px'
    },
    cellDisabled: {
      backgroundColor: '#141414',
      color: '#A6A6A6'
    },
    cellSelected: {
      backgroundColor: '#7092D7',
      color: '#141414'
    }
  },
  card: {
    root: {
      borderColor: '#525252',
      boxShadow: '0px 0px 0px 0px rgba(0, 0, 0, 0.16)',
      color: '#FFFFFF',
      fontFamily: '"iFood RC Textos", Helvetica, Arial, sans-serif',
      padding: '1px'
    },
    focusVisible: {
      borderColor: '#525252',
      outlineColor: '#FFFFFF',
      outlineOffset: '2px',
      outlineWidth: '2px'
    },
    hover: {
      backgroundColor: '#292929',
      borderColor: '#525252',
      boxShadow: '0px 0px 0px 0px rgba(0, 0, 0, 0.16)'
    },
    selected: {
      backgroundColor: '#141414',
      borderColor: '#FFFFFF',
      borderWidth: '2px',
      padding: '0px'
    },
    selectedHover: {
      backgroundColor: '#292929',
      borderColor: '#FFFFFF'
    },
    pressed: {
      backgroundColor: '#3D3D3D',
      borderColor: '#525252'
    },
    selectedFocusVisible: {
      borderColor: '#FFFFFF'
    },
    selectedPressed: {
      backgroundColor: '#3D3D3D',
      borderColor: '#FFFFFF'
    }
  },
  cardContent: {
    root: {
      fontWeight: '400',
      paddingBottom: '24px',
      paddingLeft: '24px',
      paddingRight: '24px',
      paddingTop: '24px',
      rowGap: '16px'
    },
    compact: {
      paddingBottom: '16px',
      paddingLeft: '16px',
      paddingRight: '16px',
      paddingTop: '16px'
    }
  },
  checkbox: {
    root: {
      color: '#525252',
      transitionDelay: '0ms',
      transitionDuration: '100ms',
      transitionTimingFunction: 'ease-in-out'
    },
    checked: {
      color: '#B8E0D0'
    },
    indeterminate: {
      color: '#FFFFFF'
    },
    disabled: {
      color: '#A3A3A3'
    },
    disabledIndeterminate: {
      color: '#A3A3A3'
    }
  },
  chip: {
    root: {
      backgroundColor: '#292929',
      borderRadius: '9999px',
      columnGap: '8px',
      height: '32px',
      paddingBottom: '4px',
      paddingLeft: '16px',
      paddingRight: '16px',
      paddingTop: '4px'
    },
    withEndAdornment: {
      paddingRight: '4px'
    },
    withStartAdornment: {
      paddingLeft: '8px'
    }
  },
  container: {
    root: {
      paddingInlineEnd: '0px',
      paddingInlineStart: '0px'
    },
    sm: {
      minWidth: '320px'
    },
    md: {
      minWidth: '768px'
    },
    lg: {
      minWidth: '1140px'
    },
    xl: {
      minWidth: '1366px'
    },
    maxWidthSm: {
      maxWidth: '767px'
    },
    maxWidthMd: {
      maxWidth: '1139px'
    },
    maxWidthLg: {
      maxWidth: '1365px',
      minWidth: '1140px'
    },
    maxWidthXl: {
      maxWidth: '1366px',
      minWidth: '1366px'
    },
    maxWidthSidebarLayout: {
      maxWidth: '1718px'
    },
    looseSm: {
      paddingLeft: '24px',
      paddingRight: '24px'
    },
    tightSm: {
      paddingLeft: '48px',
      paddingRight: '48px'
    },
    looseMd: {
      paddingLeft: '32px',
      paddingRight: '32px'
    },
    tightMd: {
      paddingLeft: '48px',
      paddingRight: '48px'
    },
    looseLg: {
      paddingLeft: '48px',
      paddingRight: '48px'
    },
    tightLg: {
      paddingLeft: '120px',
      paddingRight: '120px'
    },
    looseXl: {
      paddingLeft: '64px',
      paddingRight: '64px'
    },
    tightXl: {
      paddingLeft: '160px',
      paddingRight: '160px'
    }
  },
  dialog: {
    surface: {
      color: '#CCCCCC',
      fontFamily: '"iFood RC Textos", Helvetica, Arial, sans-serif',
      minHeight: '80px',
      minWidth: '200px',
      outlineColor: '#FFFFFF',
      paddingBottom: '24px',
      paddingLeft: '24px',
      paddingRight: '24px',
      paddingTop: '32px',
      rowGap: '24px',
      zIndex: '300'
    },
    container: {
      zIndex: '250'
    },
    focused: {
      outlineWidth: '0px'
    },
    focusVisible: {
      outlineWidth: '0px'
    }
  },
  dialogActions: {
    root: {
      borderTopColor: '#525252',
      borderTopWidth: '1px',
      columnGap: '16px',
      marginBlockEnd: '0px',
      marginBlockStart: '0px',
      marginInlineEnd: '0px',
      marginInlineStart: '0px',
      marginTop: '24px',
      paddingInlineStart: '0px',
      paddingTop: '24px'
    }
  },
  dialogHeader: {
    root: {
      columnGap: '24px',
      minHeight: '24px',
      paddingBottom: '0px',
      paddingLeft: '0px',
      paddingRight: '0px',
      paddingTop: '0px'
    }
  },
  drawer: {
    surface: {
      zIndex: '300'
    },
    bottomAnchor: {
      borderBottomLeftRadius: '0px',
      borderBottomRightRadius: '0px',
      borderTopLeftRadius: '16px',
      borderTopRightRadius: '16px',
      boxShadow: '0px -16px 64px 0px rgba(0, 0, 0, 0.16)'
    },
    leftAnchor: {
      borderBottomLeftRadius: '0px',
      borderBottomRightRadius: '16px',
      borderTopLeftRadius: '0px',
      borderTopRightRadius: '16px',
      boxShadow: '16px 0px 64px 0px rgba(0, 0, 0, 0.16)'
    },
    rightAnchor: {
      borderBottomLeftRadius: '16px',
      borderBottomRightRadius: '0px',
      borderTopLeftRadius: '16px',
      borderTopRightRadius: '0px',
      boxShadow: '-16px 0px 64px 0px rgba(0, 0, 0, 0.16)'
    },
    topAnchor: {
      borderBottomLeftRadius: '16px',
      borderBottomRightRadius: '16px',
      borderTopLeftRadius: '0px',
      borderTopRightRadius: '0px',
      boxShadow: '0px 16px 64px 0px rgba(0, 0, 0, 0.16)'
    },
    container: {
      paddingLeft: '0px',
      paddingRight: '0px',
      zIndex: '250'
    }
  },
  fieldWrapper: {
    root: {
      borderWidth: '0px',
      margin: '0px',
      marginInlineEnd: '0px',
      marginInlineStart: '0px',
      padding: '0px',
      paddingBlockEnd: '0px',
      paddingBlockStart: '0px',
      paddingInlineEnd: '0px',
      paddingInlineStart: '0px',
      rowGap: '8px'
    }
  },
  formHelperText: {
    root: {
      transitionDuration: '100ms',
      transitionTimingFunction: 'ease-in-out',
      lineHeight: '24px'
    },
    error: {
      color: '#EF5762'
    },
    focused: {
      color: '#EFF3FB'
    }
  },
  formLabel: {
    root: {
      minHeight: '24px'
    }
  },
  globalStyle: {
    body: {
      backgroundColor: '#141414',
      color: '#CCCCCC',
      fontFamily: '"iFood RC Textos", Helvetica, Arial, sans-serif',
      fontWeight: '400',
      marginBottom: '0px',
      marginLeft: '0px',
      marginRight: '0px',
      marginTop: '0px'
    },
    bodyBackdrop: {
      backgroundColor: '#141414'
    },
    bodyPrint: {
      backgroundColor: '#FFFFFF'
    },
    bold: {
      color: '500'
    },
    reducedMotion: {
      animationDuration: '0ms',
      transitionDuration: '0ms'
    },
    strong: {
      color: '500'
    }
  },
  gridContainer: {
    looseSm: {
      columnGap: '8px'
    },
    tightSm: {
      columnGap: '8px'
    },
    looseMd: {
      columnGap: '16px'
    },
    tightMd: {
      columnGap: '16px'
    },
    looseLg: {
      columnGap: '24px'
    },
    tightLg: {
      columnGap: '24px'
    },
    looseXl: {
      columnGap: '24px'
    },
    tightXl: {
      columnGap: '24px'
    }
  },
  header: {
    root: {
      minHeight: '64px',
      minWidth: '200px'
    },
    container: {
      columnGap: '8px',
      marginLeft: '0px',
      marginRight: '0px'
    },
    gutters: {
      marginLeft: '24px',
      marginRight: '8px'
    },
    guttersWithStartAdornment: {
      marginLeft: '8px'
    },
    content: {
      marginBottom: '24px',
      marginTop: '24px',
      minHeight: '24px',
      minWidth: '120px'
    },
    adornment: {
      columnGap: '8px',
      marginBottom: '12px',
      marginTop: '12px',
      minHeight: '48px',
      minWidth: '48px'
    }
  },
  hyperlink: {
    root: {
      borderWidth: '0px',
      color: '#FFFFFF'
    },
    hover: {
      color: '#CCCCCC'
    }
  },
  icon: {
    sm: {
      fontSize: '16px'
    },
    md: {
      fontSize: '24px'
    },
    lg: {
      fontSize: '32px'
    }
  },
  iconButton: {
    root: {
      borderRadius: '9999px',
      marginLeft: '0px',
      marginRight: '0px'
    },
    xs: {
      minHeight: '32px',
      minWidth: '32px',
      paddingBottom: '4px',
      paddingLeft: '4px',
      paddingRight: '4px',
      paddingTop: '4px'
    },
    sm: {
      minHeight: '40px',
      minWidth: '40px',
      paddingBottom: '8px',
      paddingLeft: '8px',
      paddingRight: '8px',
      paddingTop: '8px'
    },
    md: {
      minHeight: '48px',
      minWidth: '48px',
      paddingBottom: '12px',
      paddingLeft: '12px',
      paddingRight: '12px',
      paddingTop: '12px'
    },
    edgeStart: {
      marginLeft: '-8px',
      marginRight: '0px'
    },
    edgeEnd: {
      marginLeft: '0px',
      marginRight: '-8px'
    }
  },
  input: {
    root: {
      fontFamily: '"iFood RC Textos", Helvetica, Arial, sans-serif',
      fontSize: '16px',
      height: '56px',
      lineHeight: '24px',
      padding: '16px',
      zIndex: '0'
    },
    disabled: {
      backgroundColor: '#B8B8B8',
      borderColor: '{color.component.onBackground.disabled',
      color: '#A3A3A3'
    },
    error: {
      backgroundColor: '#700A11',
      borderColor: '#EF5762',
      borderWidth: '1px',
      color: '#FDECEE'
    },
    focused: {
      backgroundColor: '#141414',
      borderColor: '#525252',
      borderWidth: '1px',
      color: '#FFFFFF',
      outlineColor: '#FFFFFF',
      outlineOffset: '2px',
      outlineWidth: '2px'
    },
    placeholder: '#A3A3A3'
  },
  inputAdornment: {
    positionStart: {
      marginLeft: '16px',
      marginRight: '0px'
    },
    positionEnd: {
      marginLeft: '16px',
      marginRight: '16px'
    }
  },
  inputLabel: {
    root: {
      color: '#FFFFFF',
      marginBottom: '0px',
      transitionDuration: '250ms',
      transitionTimingFunction: 'ease-in',
      zIndex: '0'
    },
    error: {
      color: '#EF5762'
    },
    focused: {
      color: '#EFF3FB'
    }
  },
  list: {
    root: {
      marginBlockEnd: '0px',
      marginBlockStart: '0px',
      marginBottom: '0px',
      marginLeft: '0px',
      marginInlineEnd: '0px',
      marginInlineStart: '0px',
      marginRight: '0px',
      marginTop: '0px',
      paddingBottom: '0px',
      paddingInlineStart: '0px',
      paddingLeft: '0px',
      paddingRight: '0px',
      paddingTop: '0px'
    }
  },
  listItem: {
    root: {
      borderBottomColor: '#525252',
      borderBottomWidth: '1px',
      paddingLeft: '0px',
      paddingRight: '0px'
    },
    expanded: {
      paddingBottom: '32px',
      paddingTop: '32px'
    },
    compact: {
      paddingBottom: '24px',
      paddingTop: '24px'
    },
    last: {
      borderBottomWidth: '0px'
    }
  },
  listRow: {
    root: {
      color: '#CCCCCC',
      fontFamily: '"iFood RC Textos", Helvetica, Arial, sans-serif',
      fontSize: '14px',
      lineHeight: '24px',
      paddingTop: '20px',
      paddingRight: '0px',
      paddingBottom: '20px',
      paddingLeft: '0px',
      borderBottomColor: '#525252'
    }
  },
  menuItem: {
    root: {
      backgroundColor: '#141414',
      color: '#A3A3A3',
      fontWeight: '400',
      marginBottom: '0px',
      marginTop: '0px',
      minHeight: '48px',
      paddingBottom: '12px',
      paddingLeft: '16px',
      paddingRight: '16px',
      paddingTop: '12px',
      transitionDelay: '0ms',
      transitionDuration: '100ms',
      transitionTimingFunction: 'ease-in-out'
    },
    before: {
      backgroundColor: '#FFFFFF',
      borderBottomLeftRadius: '0px',
      borderBottomRightRadius: '4px',
      borderTopLeftRadius: '0px',
      borderTopRightRadius: '4px',
      height: '32px',
      opacity: '0',
      width: '2px'
    },
    focused: {
      backgroundColor: '#292929',
      color: '#FFFFFF',
      opacity: '1'
    },
    gutters: {
      paddingLeft: '24px',
      paddingRight: '24px'
    },
    hover: {
      backgroundColor: '#141414'
    },
    selected: {
      backgroundColor: '#292929',
      color: '#CCCCCC',
      fontWeight: '500'
    },
    selectedBefore: {
      opacity: '1'
    },
    selectedHover: {
      backgroundColor: '#292929'
    },
    selectedHoverNone: {
      backgroundColor: '#292929'
    }
  },
  menuItemIcon: {
    root: {
      height: '24px',
      marginRight: '16px',
      minHeight: '24px',
      minWidth: '24px',
      width: '24px'
    }
  },
  menuItemText: {
    root: {
      marginBottom: '0px',
      marginLeft: '0px',
      marginRight: '0px',
      marginTop: '0px',
      minWidth: '0px',
      transitionDelay: '0ms',
      transitionDuration: '50ms',
      transitionTimingFunction: 'ease-in-out'
    }
  },
  menuList: {
    root: {
      borderRadius: '0px',
      borderTopWidth: '0px',
      boxShadow: '0px 0px 0px 0px rgba(0, 0, 0, 0.16)'
    }
  },
  navBar: {
    root: {
      borderBottomColor: '#525252',
      borderBottomWidth: '1px',
      fontFamily: '"iFood RC Textos", Helvetica, Arial, sans-serif',
      margin: '0px',
      minHeight: '56px',
      zIndex: '100'
    },
    positionFixed: {
      zIndex: '99'
    },
    prominent: {
      minHeight: '80px',
      paddingBottom: '0px',
      paddingTop: '0px'
    },
    container: {
      minHeight: '48px'
    },
    maxWidthSidebarLayoutContainer: {
      paddingLeft: '32px',
      paddingRight: '32px'
    },
    prominentContainer: {
      paddingBottom: '16px',
      paddingTop: '16px'
    }
  },
  overlay: {
    root: {
      backgroundColor: 'rgba(255, 255, 255, 0.32)',
      opacity: '1',
      zIndex: '200'
    }
  },
  pageHeader: {
    heading: {
      marginBottom: '8px',
      marginTop: '0px'
    },
    text: {
      marginBottom: '0px',
      marginTop: '0px'
    }
  },
  pagination: {
    root: {
      fontFamily: '"iFood RC Textos", Helvetica, Arial, sans-serif',
      minHeight: '24px',
      minWidth: '24px'
    },
    list: {
      columnGap: '8px',
      margin: '0px',
      padding: '0px'
    },
    item: {
      color: '#FFFFFF'
    },
    disabledItem: {
      color: '#A3A3A3'
    },
    ellipsis: {
      color: '#FFFFFF'
    }
  },
  passwordInput: {
    toggle: {
      paddingTop: '4px',
      paddingRight: '4px',
      paddingBottom: '4px',
      paddingLeft: '4px'
    }
  },
  progressBar: {
    root: {
      backgroundColor: '#141414',
      borderRadius: '9999px',
      borderWidth: '0px',
      height: '4px',
      minWidth: '200px',
      zIndex: '0'
    },
    progressBar: {
      borderRadius: '9999px',
      height: '4px'
    },
    progressValue: {
      transitionDelay: '0ms',
      transitionDuration: '250ms',
      transitionTimingFunction: 'ease-in-out',
      zIndex: '10'
    },
    success: {
      backgroundColor: '#B8E0D0'
    },
    informative: {
      backgroundColor: '#7092D7'
    },
    critical: {
      backgroundColor: '#EF5762'
    },
    attention: {
      backgroundColor: '#C1840B'
    }
  },
  select: {
    root: {
      borderWidth: '0px',
      fontFamily: '"iFood RC Textos", Helvetica, Arial, sans-serif',
      marginInlineEnd: '0px',
      marginInlineStart: '0px',
      minHeight: '56px',
      paddingBlockEnd: '0px',
      paddingBlockStart: '0px',
      paddingInlineEnd: '0px',
      paddingInlineStart: '0px'
    },
    control: {
      backgroundColor: '#141414',
      borderColor: '#525252',
      borderRadius: '2px',
      borderWidth: '1px',
      boxShadow: '0px 0px 0px 0px rgba(0, 0, 0, 0.16)',
      color: '#CCCCCC'
    },
    controlError: {
      backgroundColor: '#700A11',
      borderColor: '#EF5762',
      borderWidth: '1px',
      color: '#FDECEE'
    },
    controlFocused: {
      borderColor: '#525252',
      outlineColor: '#FFFFFF',
      outlineOffset: '2px',
      outlineWidth: '2px'
    },
    controlHover: {
      borderColor: '#525252'
    },
    disabledControl: {
      backgroundColor: '#B8B8B8'
    },
    disabledIndicator: {
      color: '#A3A3A3'
    },
    indicator: {
      color: '#CCCCCC',
      paddingBottom: '16px',
      paddingLeft: '16px',
      paddingRight: '16px',
      paddingTop: '16px'
    },
    indicatorError: {
      color: '#FDECEE'
    },
    menu: {
      borderBottomWidth: '1px',
      borderColor: '#525252',
      borderLeftWidth: '1px',
      borderRightWidth: '1px',
      zIndex: '50'
    },
    menuOption: {
      backgroundColor: '#141414',
      color: '#FFFFFF',
      paddingBottom: '16px',
      paddingLeft: '16px',
      paddingRight: '16px',
      paddingTop: '16px'
    },
    menuOptionSelected: {
      backgroundColor: '#FFFFFF',
      color: '#141414',
      opacity: '1'
    },
    placeholder: {
      color: '#A3A3A3',
      fontWeight: '400',
      fontSize: '16px',
      letterSpacing: '0px',
      lineHeight: '24px',
      marginBottom: '2px'
    },
    placeholderError: {
      color: '#FDECEE'
    },
    singleValue: {
      color: '#FFFFFF'
    },
    inputContainer: {
      marginTop: '0px',
      marginRight: '0px',
      marginBottom: '0px',
      marginLeft: '0px'
    },
    valueContainer: {
      paddingTop: '16px',
      paddingRight: '16px',
      paddingBottom: '16px',
      paddingLeft: '16px'
    }
  },
  shape: {
    circle: {
      borderRadius: '100%'
    },
    ellipse: {
      borderRadius: '100%'
    },
    pill: {
      borderRadius: '9999px'
    },
    rectangle: {
      borderRadius: '0px'
    },
    square: {
      borderRadius: '0px'
    }
  },
  sidebar: {
    root: {
      backgroundColor: '#141414',
      zIndex: '10'
    }
  },
  sidebarLayout: {
    sidebar: {
      borderRightColor: '#525252',
      borderRightWidth: '1px'
    }
  },
  skeleton: {
    skeleton: {
      animationDelay: '400ms',
      animationTimingFunction: 'ease-in-out'
    }
  },
  storybook: {
    app: {
      backgroundColor: '#292929',
      borderColor: '#525252',
      borderRadius: '4px'
    },
    appContent: {
      backgroundColor: '#141414'
    },
    bar: {
      backgroundColor: '#292929',
      color: '#FFFFFF'
    },
    barSelected: {
      color: '#FA5266'
    },
    primary: {
      color: '#FA5266'
    },
    secondary: {
      color: '#FFFFFF'
    },
    text: {
      color: '#FFFFFF',
      fontFamily: '"iFood RC Textos", Helvetica, Arial, sans-serif'
    },
    textInverse: {
      color: '#141414'
    },
    input: {
      backgroundColor: '#141414',
      borderColor: '#525252',
      borderRadius: '2px',
      color: '#FFFFFF'
    }
  },
  surface: {
    root: {
      backgroundColor: '#141414',
      borderColor: '#525252',
      borderRadius: '0px',
      borderWidth: '0px',
      boxShadow: '0px 0px 0px 0px rgba(0, 0, 0, 0.16)',
      color: '#FFFFFF',
      transitionDelay: '0ms',
      transitionDuration: '100ms',
      transitionTimingFunction: 'ease-in-out'
    },
    outlined: {
      borderWidth: '1px'
    },
    shapeStylePill: {
      borderRadius: '9999px'
    },
    shapeStyleRounded: {
      borderRadius: '4px'
    },
    shapeStyleSemiSquare: {
      borderRadius: '2px'
    },
    shadowLowest: {
      boxShadow: '0px 2px 2px 0px rgba(0, 0, 0, 0.16)'
    },
    colorLowest: {
      backgroundColor: '#292929'
    }
  },
  tab: {
    root: {
      borderBottomColor: '#525252',
      borderBottomWidth: '1px',
      borderTopLeftRadius: '2px',
      borderTopRightRadius: '2px',
      color: '#A3A3A3',
      fontWeight: '400',
      height: '56px',
      minWidth: '80px',
      transitionDelay: '0ms',
      transitionDuration: '100ms',
      transitionTimingFunction: 'ease-in-out',
      zIndex: '0'
    },
    tabStatus: {
      maxWidth: '160px'
    },
    rootBefore: {
      backgroundColor: 'rgba(255, 255, 255, 0)',
      paddingLeft: '2px',
      zIndex: '0'
    },
    rootAfter: {
      paddingRight: '2px',
      zIndex: '10'
    },
    content: {
      borderRadius: '2px',
      marginBottom: '16px',
      height: '40px',
      paddingBottom: '8px',
      paddingTop: '8px',
      zIndex: '50'
    },
    standardContent: {
      paddingLeft: '16px',
      paddingRight: '16px'
    },
    compactContent: {
      paddingLeft: '8px',
      paddingRight: '8px'
    },
    hover: {
      color: '#CCCCCC'
    },
    hoverBefore: {
      backgroundColor: '#292929'
    },
    hoverAfter: {
      backgroundColor: 'rgba(224, 224, 224, 0.08)'
    },
    focusVisible: {
      borderBottomColor: 'rgba(255, 255, 255, 0)',
      borderBottomLeftRadius: '2px',
      borderBottomRightRadius: '2px',
      color: '#CCCCCC',
      outlineColor: '#FFFFFF',
      outlineOffset: '2px',
      outlineWidth: '2px'
    },
    focusVisibleBefore: {
      backgroundColor: '#292929'
    },
    focusVisibleAfter: {
      backgroundColor: 'rgba(224, 224, 224, 0.08)'
    },
    pressed: {
      color: '#CCCCCC'
    },
    pressedBefore: {
      backgroundColor: '#3D3D3D'
    },
    pressedAfter: {
      backgroundColor: 'rgba(224, 224, 224, 0.08)'
    },
    selected: {
      borderBottomColor: '#FFFFFF',
      color: '#FFFFFF',
      fontWeight: '700'
    },
    selectedBefore: {
      backgroundColor: '#292929'
    },
    selectedHover: {
      color: '#FFFFFF'
    },
    selectedHoverBefore: {
      backgroundColor: '#292929'
    },
    selectedHoverAfter: {
      backgroundColor: 'rgba(224, 224, 224, 0.08)'
    },
    selectedPressed: {
      color: '#FFFFFF'
    },
    selectedPressedBefore: {
      backgroundColor: '#3D3D3D'
    },
    selectedPressedAfter: {
      backgroundColor: 'rgba(224, 224, 224, 0.08)'
    },
    selectedFocusVisible: {
      color: '#FFFFFF'
    },
    disabled: {
      color: '#B8B8B8'
    },
    startAdornment: {
      marginLeft: '0px',
      marginRight: '8px'
    },
    endAdornment: {
      marginLeft: '8px',
      marginRight: '0px'
    }
  },
  tabBar: {
    root: {
      paddingBottom: '16px',
      paddingTop: '0px'
    },
    gutterTop: {
      paddingTop: '32px'
    },
    after: {
      borderBottomColor: '#525252',
      borderBottomWidth: '1px'
    }
  },
  table: {
    root: {
      borderSpacing: '8px',
      color: '#CCCCCC',
      fontFamily: '"iFood RC Textos", Helvetica, Arial, sans-serif',
      fontWeight: '400',
      fontSize: '14px',
      lineHeight: '24px'
    }
  },
  tableCell: {
    root: {
      backgroundColor: '#141414',
      paddingBottom: '8px',
      paddingLeft: '16px',
      paddingRight: '16px',
      paddingTop: '8px',
      height: '56px',
      minHeight: '56px'
    },
    checkboxPadding: {
      maxHeight: '48px',
      minHeight: '48px',
      minWidth: '40px',
      width: '48px'
    },
    densePadding: {
      height: '80px',
      minHeight: '80px'
    },
    head: {
      backgroundColor: '#292929',
      borderRadius: '4px'
    }
  },
  tableHead: {
    root: {
      backgroundColor: '#292929',
      color: '#FFFFFF',
      fontFamily: '"iFood RC Textos", Helvetica, Arial, sans-serif',
      fontWeight: '500'
    }
  },
  tableRow: {
    root: {
      outlineWidth: '0px'
    },
    hover: {
      backgroundColor: '#292929'
    },
    selected: {
      backgroundColor: '#292929'
    }
  },
  tabPanel: {
    root: {
      paddingTop: '24px'
    }
  },
  tooltip: {
    root: {
      animationDuration: '100ms',
      animationTimingFunction: 'ease-in-out',
      borderRadius: '4px',
      fontFamily: '"iFood RC Textos", Helvetica, Arial, sans-serif',
      fontSize: '12px',
      lineHeight: '16px',
      paddingBottom: '8px',
      paddingLeft: '8px',
      paddingRight: '8px',
      paddingTop: '8px',
      transitionDuration: '100ms',
      transitionTimingFunction: 'ease-in-out',
      zIndex: '500'
    },
    arrowBottom: {
      left: '4px'
    },
    arrowBottomLeft: {
      right: '8px'
    },
    arrowBottomRight: {
      left: '8px'
    },
    arrowLeft: {
      right: '16px'
    },
    arrowRight: {
      left: '16px'
    },
    arrowTop: {
      left: '4px'
    },
    arrowTopLeft: {
      right: '8px'
    },
    arrowTopRight: {
      left: '8px'
    },
    'arrow-attention': {
      fill: '#C1840B'
    },
    'arrow-critical': {
      fill: '#EF5762'
    },
    'arrow-default': {
      fill: '#FFEBEF'
    },
    'arrow-informative': {
      fill: '#7092D7'
    },
    'arrow-success': {
      fill: '#B8E0D0'
    },
    attention: {
      color: '#FFFFFF',
      backgroundColor: '#C1840B'
    },
    critical: {
      color: '#141414',
      backgroundColor: '#EF5762'
    },
    containerBottom: {
      top: '16px'
    },
    containerBottomLeft: {
      top: '16px',
      right: '24px'
    },
    containerBottomRight: {
      top: '16px',
      left: '24px'
    },
    containerLeft: {
      right: '16px'
    },
    containerRight: {
      left: '16px'
    },
    containerTop: {
      bottom: '16px'
    },
    containerTopLeft: {
      bottom: '16px',
      right: '24px'
    },
    containerTopRight: {
      bottom: '16px',
      left: '24px'
    },
    "default": {
      color: '#141414',
      backgroundColor: '#FFEBEF'
    },
    hidden: {
      opacity: '0'
    },
    informative: {
      color: '#141414',
      backgroundColor: '#7092D7'
    },
    success: {
      color: '#141414',
      backgroundColor: '#B8E0D0'
    },
    shown: {
      opacity: '1'
    }
  },
  typography: {
    root: {
      marginBlockEnd: '0px',
      marginBlockStart: '0px',
      marginBottom: '0px',
      marginLeft: '0px',
      marginInlineEnd: '0px',
      marginInlineStart: '0px',
      marginRight: '0px',
      marginTop: '0px'
    },
    display: {
      color: '#FFFFFF',
      fontFamily: '"iFood RC Textos", Helvetica, Arial, sans-serif',
      fontWeight: '400',
      letterSpacing: '-2px'
    },
    displayDesktop: {
      fontSize: '48px',
      fontWeight: '400',
      letterSpacing: '-2px',
      lineHeight: '56px'
    },
    displayDesktopGutterBottom: {
      marginBottom: '48px'
    },
    displayMobile: {
      fontSize: '40px',
      fontWeight: '400',
      letterSpacing: '-2px',
      lineHeight: '48px'
    },
    displayMobileGutterBottom: {
      marginBottom: '40px'
    },
    heading1: {
      color: '#FFFFFF',
      fontFamily: '"iFood RC Textos", Helvetica, Arial, sans-serif'
    },
    heading1Desktop: {
      fontSize: '40px',
      fontWeight: '400',
      letterSpacing: '-2px',
      lineHeight: '48px'
    },
    heading1DesktopGutterBottom: {
      marginBottom: '40px'
    },
    heading1Mobile: {
      fontSize: '32px',
      fontWeight: '500',
      letterSpacing: '-1px',
      lineHeight: '40px'
    },
    heading1MobileGutterBottom: {
      marginBottom: '32px'
    },
    heading2: {
      color: '#FFFFFF',
      fontFamily: '"iFood RC Textos", Helvetica, Arial, sans-serif'
    },
    heading2Desktop: {
      fontSize: '32px',
      fontWeight: '500',
      letterSpacing: '-1px',
      lineHeight: '40px'
    },
    heading2DesktopGutterBottom: {
      marginBottom: '32px'
    },
    heading2Mobile: {
      fontSize: '24px',
      fontWeight: '500',
      letterSpacing: '-1px',
      lineHeight: '32px'
    },
    heading2MobileGutterBottom: {
      marginBottom: '24px'
    },
    heading3: {
      color: '#FFFFFF',
      fontFamily: '"iFood RC Textos", Helvetica, Arial, sans-serif'
    },
    heading3Desktop: {
      fontSize: '24px',
      fontWeight: '500',
      letterSpacing: '-1px',
      lineHeight: '32px'
    },
    heading3DesktopGutterBottom: {
      marginBottom: '24px'
    },
    heading3Mobile: {
      fontSize: '20px',
      fontWeight: '500',
      letterSpacing: '-1px',
      lineHeight: '24px'
    },
    heading3MobileGutterBottom: {
      marginBottom: '16px'
    },
    heading4: {
      color: '#FFFFFF',
      fontFamily: '"iFood RC Textos", Helvetica, Arial, sans-serif'
    },
    heading4Desktop: {
      fontSize: '20px',
      fontWeight: '500',
      letterSpacing: '-1px',
      lineHeight: '24px'
    },
    heading4DesktopGutterBottom: {
      marginBottom: '16px'
    },
    heading4Mobile: {
      fontSize: '16px',
      fontWeight: '500',
      letterSpacing: '-1px',
      lineHeight: '16px'
    },
    heading4MobileGutterBottom: {
      marginBottom: '8px'
    },
    body1: {
      color: '#CCCCCC',
      fontFamily: '"iFood RC Textos", Helvetica, Arial, sans-serif',
      letterSpacing: '0px'
    },
    body1Desktop: {
      fontSize: '16px',
      lineHeight: '24px'
    },
    body1DesktopGutterBottom: {
      marginBottom: '40px'
    },
    body1Mobile: {
      fontSize: '16px',
      lineHeight: '24px'
    },
    body1MobileGutterBottom: {
      marginBottom: '40px'
    },
    body2: {
      color: '#CCCCCC',
      fontFamily: '"iFood RC Textos", Helvetica, Arial, sans-serif',
      letterSpacing: '0px'
    },
    body2Desktop: {
      fontSize: '14px',
      lineHeight: '24px'
    },
    body2DesktopGutterBottom: {
      marginBottom: '40px'
    },
    body2Mobile: {
      fontSize: '14px',
      lineHeight: '24px'
    },
    body2MobileGutterBottom: {
      marginBottom: '40px'
    },
    body3: {
      color: '#CCCCCC',
      fontFamily: '"iFood RC Textos", Helvetica, Arial, sans-serif',
      letterSpacing: '0px'
    },
    body3Desktop: {
      fontSize: '12px',
      lineHeight: '16px'
    },
    body3DesktopGutterBottom: {
      marginBottom: '40px'
    },
    body3Mobile: {
      fontSize: '12px',
      lineHeight: '16px'
    },
    body3MobileGutterBottom: {
      marginBottom: '40px'
    },
    regular: {
      fontWeight: '400'
    },
    medium: {
      fontWeight: '500'
    },
    bold: {
      fontWeight: '700'
    }
  }
};

/**
 * Do not edit this file directly
 * Generated by the Style Dictionary Builder.
 */
var fontFamilyIfoodBody = "'iFood RC Textos', Helvetica, Arial, sans-serif";
var fontFamilyIfoodHeading = "'iFood RC Textos', Helvetica, Arial, sans-serif";
var fontFamilyBody = "'iFood RC Textos', Helvetica, Arial, sans-serif"; // This is the font family used for prose text. Suitable for 16px font sizes or less.

var fontFamilyHeading = "'iFood RC Textos', Helvetica, Arial, sans-serif"; // This is the font family used for headings and subheadings.

var badgeComponentTokenRootFontFamily = "'iFood RC Textos', Helvetica, Arial, sans-serif";
var buttonBaseComponentTokenRootFontFamily = "'iFood RC Textos', Helvetica, Arial, sans-serif";
var calendarComponentTokenRootFontFamily = "'iFood RC Textos', Helvetica, Arial, sans-serif";
var calendarComponentTokenHeaderFontFamily = "'iFood RC Textos', Helvetica, Arial, sans-serif";
var calendarComponentTokenCellFontFamily = "'iFood RC Textos', Helvetica, Arial, sans-serif";
var cardComponentTokenRootFontFamily = "'iFood RC Textos', Helvetica, Arial, sans-serif";
var dialogComponentTokenSurfaceFontFamily = "'iFood RC Textos', Helvetica, Arial, sans-serif";
var globalStyleComponentTokenBodyFontFamily = "'iFood RC Textos', Helvetica, Arial, sans-serif";
var inputComponentTokenRootFontFamily = "'iFood RC Textos', Helvetica, Arial, sans-serif";
var listRowComponentTokenRootFontFamily = "'iFood RC Textos', Helvetica, Arial, sans-serif";
var navBarComponentTokenRootFontFamily = "'iFood RC Textos', Helvetica, Arial, sans-serif";
var paginationComponentTokenRootFontFamily = "'iFood RC Textos', Helvetica, Arial, sans-serif";
var selectComponentTokenRootFontFamily = "'iFood RC Textos', Helvetica, Arial, sans-serif";
var storybookComponentTokenTextFontFamily = "'iFood RC Textos', Helvetica, Arial, sans-serif"; // fontBase

var tableComponentTokenRootFontFamily = "'iFood RC Textos', Helvetica, Arial, sans-serif";
var tableHeadComponentTokenRootFontFamily = "'iFood RC Textos', Helvetica, Arial, sans-serif";
var tooltipComponentTokenRootFontFamily = "'iFood RC Textos', Helvetica, Arial, sans-serif";
var typographyComponentTokenDisplayFontFamily = "'iFood RC Textos', Helvetica, Arial, sans-serif";
var typographyComponentTokenHeading1FontFamily = "'iFood RC Textos', Helvetica, Arial, sans-serif";
var typographyComponentTokenHeading2FontFamily = "'iFood RC Textos', Helvetica, Arial, sans-serif";
var typographyComponentTokenHeading3FontFamily = "'iFood RC Textos', Helvetica, Arial, sans-serif";
var typographyComponentTokenHeading4FontFamily = "'iFood RC Textos', Helvetica, Arial, sans-serif";
var typographyComponentTokenBody1FontFamily = "'iFood RC Textos', Helvetica, Arial, sans-serif";
var typographyComponentTokenBody2FontFamily = "'iFood RC Textos', Helvetica, Arial, sans-serif";
var typographyComponentTokenBody3FontFamily = "'iFood RC Textos', Helvetica, Arial, sans-serif";

var fontFamily = {
  __proto__: null,
  fontFamilyIfoodBody: fontFamilyIfoodBody,
  fontFamilyIfoodHeading: fontFamilyIfoodHeading,
  fontFamilyBody: fontFamilyBody,
  fontFamilyHeading: fontFamilyHeading,
  badgeComponentTokenRootFontFamily: badgeComponentTokenRootFontFamily,
  buttonBaseComponentTokenRootFontFamily: buttonBaseComponentTokenRootFontFamily,
  calendarComponentTokenRootFontFamily: calendarComponentTokenRootFontFamily,
  calendarComponentTokenHeaderFontFamily: calendarComponentTokenHeaderFontFamily,
  calendarComponentTokenCellFontFamily: calendarComponentTokenCellFontFamily,
  cardComponentTokenRootFontFamily: cardComponentTokenRootFontFamily,
  dialogComponentTokenSurfaceFontFamily: dialogComponentTokenSurfaceFontFamily,
  globalStyleComponentTokenBodyFontFamily: globalStyleComponentTokenBodyFontFamily,
  inputComponentTokenRootFontFamily: inputComponentTokenRootFontFamily,
  listRowComponentTokenRootFontFamily: listRowComponentTokenRootFontFamily,
  navBarComponentTokenRootFontFamily: navBarComponentTokenRootFontFamily,
  paginationComponentTokenRootFontFamily: paginationComponentTokenRootFontFamily,
  selectComponentTokenRootFontFamily: selectComponentTokenRootFontFamily,
  storybookComponentTokenTextFontFamily: storybookComponentTokenTextFontFamily,
  tableComponentTokenRootFontFamily: tableComponentTokenRootFontFamily,
  tableHeadComponentTokenRootFontFamily: tableHeadComponentTokenRootFontFamily,
  tooltipComponentTokenRootFontFamily: tooltipComponentTokenRootFontFamily,
  typographyComponentTokenDisplayFontFamily: typographyComponentTokenDisplayFontFamily,
  typographyComponentTokenHeading1FontFamily: typographyComponentTokenHeading1FontFamily,
  typographyComponentTokenHeading2FontFamily: typographyComponentTokenHeading2FontFamily,
  typographyComponentTokenHeading3FontFamily: typographyComponentTokenHeading3FontFamily,
  typographyComponentTokenHeading4FontFamily: typographyComponentTokenHeading4FontFamily,
  typographyComponentTokenBody1FontFamily: typographyComponentTokenBody1FontFamily,
  typographyComponentTokenBody2FontFamily: typographyComponentTokenBody2FontFamily,
  typographyComponentTokenBody3FontFamily: typographyComponentTokenBody3FontFamily
};

/**
 * Do not edit this file directly
 * Generated by the Style Dictionary Builder.
 */
var fontLineHeightScaleXs = '16px';
var fontLineHeightScaleMi = '20px';
var fontLineHeightScaleSm = '24px';
var fontLineHeightScaleMd = '32px';
var fontLineHeightScaleLg = '40px';
var fontLineHeightScaleXl = '48px';
var fontLineHeightScale2Xl = '56px';
var fontLineHeightScale3Xl = '72px';
var fontLineHeightScale4Xl = '80px';
var fontLineHeightScale5Xl = '88px';
var fontLineHeightScale6Xl = '112px';

var lineHeight = {
  __proto__: null,
  fontLineHeightScaleXs: fontLineHeightScaleXs,
  fontLineHeightScaleMi: fontLineHeightScaleMi,
  fontLineHeightScaleSm: fontLineHeightScaleSm,
  fontLineHeightScaleMd: fontLineHeightScaleMd,
  fontLineHeightScaleLg: fontLineHeightScaleLg,
  fontLineHeightScaleXl: fontLineHeightScaleXl,
  fontLineHeightScale2Xl: fontLineHeightScale2Xl,
  fontLineHeightScale3Xl: fontLineHeightScale3Xl,
  fontLineHeightScale4Xl: fontLineHeightScale4Xl,
  fontLineHeightScale5Xl: fontLineHeightScale5Xl,
  fontLineHeightScale6Xl: fontLineHeightScale6Xl
};

/**
 * Do not edit this file directly
 * Generated by the Style Dictionary Builder.
 */
var fontSizeScale4Xs = '10px';
var fontSizeScale3Xs = '12px';
var fontSizeScale2Xs = '14px';
var fontSizeScaleXs = '16px';
var fontSizeScaleXs18 = '18px';
var fontSizeScaleSm = '20px';
var fontSizeScaleMd = '24px';
var fontSizeScaleLg = '32px';
var fontSizeScaleXl = '36px';
var fontSizeScale2Xl = '40px';
var fontSizeScale3Xl = '48px';
var fontSizeScale4Xl = '64px';
var fontSizeScale5Xl = '72px';
var fontSizeScale6Xl = '96px';
var fontSizeScale7Xl = '128px';

var fontSize = {
  __proto__: null,
  fontSizeScale4Xs: fontSizeScale4Xs,
  fontSizeScale3Xs: fontSizeScale3Xs,
  fontSizeScale2Xs: fontSizeScale2Xs,
  fontSizeScaleXs: fontSizeScaleXs,
  fontSizeScaleXs18: fontSizeScaleXs18,
  fontSizeScaleSm: fontSizeScaleSm,
  fontSizeScaleMd: fontSizeScaleMd,
  fontSizeScaleLg: fontSizeScaleLg,
  fontSizeScaleXl: fontSizeScaleXl,
  fontSizeScale2Xl: fontSizeScale2Xl,
  fontSizeScale3Xl: fontSizeScale3Xl,
  fontSizeScale4Xl: fontSizeScale4Xl,
  fontSizeScale5Xl: fontSizeScale5Xl,
  fontSizeScale6Xl: fontSizeScale6Xl,
  fontSizeScale7Xl: fontSizeScale7Xl
};

/**
 * Do not edit this file directly
 * Generated by the Style Dictionary Builder.
 */
var fontWeightLight = '300';
var fontWeightRegular = '400';
var fontWeightMedium = '500';
var fontWeightBold = '700';
var fontWeightExtraBold = '400';

var fontWeight = {
  __proto__: null,
  fontWeightLight: fontWeightLight,
  fontWeightRegular: fontWeightRegular,
  fontWeightMedium: fontWeightMedium,
  fontWeightBold: fontWeightBold,
  fontWeightExtraBold: fontWeightExtraBold
};

/**
 * Do not edit this file directly
 * Generated by the Style Dictionary Builder.
 */
var colorReferenceBrand016$1 = '#4B070C';
var colorReferenceBrand024$1 = '#7A001A';
var colorReferenceBrand032$1 = '#A30023';
var colorReferenceBrand040$1 = '#C01D31'; // Former color.brand.low

var colorReferenceBrand048$1 = '#EB0033';
var colorReferenceBrand056$1 = '#E83F53';
var colorReferenceBrand064$1 = '#FA5266';
var colorReferenceBrand072$1 = '#F37C84';
var colorReferenceBrand080$1 = '#FF99AF';
var colorReferenceBrand088$1 = '#FFC2CF';
var colorReferenceBrand096$1 = '#FFEBEF';
var colorReferenceInformative016$1 = '#122140';
var colorReferenceInformative024$1 = '#1B325F';
var colorReferenceInformative032$1 = '#24427F';
var colorReferenceInformative040$1 = '#2D539F';
var colorReferenceInformative048$1 = '#3664BF';
var colorReferenceInformative056$1 = '#507ACE';
var colorReferenceInformative064$1 = '#7092D7';
var colorReferenceInformative072$1 = '#90AAE0';
var colorReferenceInformative080$1 = '#AFC2E9'; // Former color.informative.medium

var colorReferenceInformative088$1 = '#CFDBF2';
var colorReferenceInformative096$1 = '#EFF3FB';
var colorReferenceSuccess016$1 = '#19392C';
var colorReferenceSuccess024$1 = '#255542';
var colorReferenceSuccess032$1 = '#327258';
var colorReferenceSuccess040$1 = '#3E8E6E';
var colorReferenceSuccess048$1 = '#4AAA85';
var colorReferenceSuccess056$1 = '#63BB98';
var colorReferenceSuccess064$1 = '#7FC7AB';
var colorReferenceSuccess072$1 = '#9CD4BE';
var colorReferenceSuccess080$1 = '#B8E0D0';
var colorReferenceSuccess088$1 = '#D4ECE3';
var colorReferenceSuccess096$1 = '#F1F9F6';
var colorReferenceCritical016$1 = '#4B070C';
var colorReferenceCritical024$1 = '#700A11';
var colorReferenceCritical032$1 = '#950E18';
var colorReferenceCritical040$1 = '#BB111C'; // Former color.brand.low

var colorReferenceCritical048$1 = '#E01524';
var colorReferenceCritical056$1 = '#EC323F';
var colorReferenceCritical064$1 = '#EF5762';
var colorReferenceCritical072$1 = '#F37C84';
var colorReferenceCritical080$1 = '#F6A2A8';
var colorReferenceCritical088$1 = '#FAC7CB';
var colorReferenceCritical096$1 = '#FDECEE';
var colorReferenceAttention016$1 = '#4D3504';
var colorReferenceAttention024$1 = '#744F07';
var colorReferenceAttention032$1 = '#9A6A09';
var colorReferenceAttention040$1 = '#C1840B';
var colorReferenceAttention048$1 = '#E79F0D';
var colorReferenceAttention056$1 = '#F3B02B';
var colorReferenceAttention064$1 = '#F5BE51';
var colorReferenceAttention072$1 = '#F7CD78';
var colorReferenceAttention080$1 = '#F9DB9F';
var colorReferenceAttention088$1 = '#FCE9C5';
var colorReferenceAttention096$1 = '#FEF8EC';
var colorReferenceNeutral100$1 = '#FFFFFF'; // Former color.neutralLight.pure

var colorReferenceNeutral008$1 = '#141414';
var colorReferenceNeutral016$1 = '#292929';
var colorReferenceNeutral024$1 = '#3D3D3D';
var colorReferenceNeutral032$1 = '#525252';
var colorReferenceNeutral040$1 = '#666666';
var colorReferenceNeutral048$1 = '#7A7A7A';
var colorReferenceNeutral056$1 = '#8F8F8F';
var colorReferenceNeutral064$1 = '#A3A3A3';
var colorReferenceNeutral072$1 = '#B8B8B8';
var colorReferenceNeutral080$1 = '#CCCCCC'; // Former color.neutralLight.medium

var colorReferenceNeutral088$1 = '#E0E0E0';
var colorReferenceNeutral096$1 = '#F5F5F5';
var colorReferenceCraftSecondary016$1 = '#421033';
var colorReferenceCraftSecondary024$1 = '#63174D';
var colorReferenceCraftSecondary032$1 = '#841F67';
var colorReferenceCraftSecondary040$1 = '#A52781';
var colorReferenceCraftSecondary048$1 = '#C62F9A';
var colorReferenceCraftSecondary056$1 = '#D449AC';
var colorReferenceCraftSecondary064$1 = '#DC6ABB';
var colorReferenceCraftSecondary072$1 = '#ECACD9';
var colorReferenceCraftSecondary080$1 = '#ECACD9';
var colorReferenceCraftSecondary088$1 = '#F3CDE8';
var colorReferenceCraftSecondary096$1 = '#FBEEF7';
var colorReferenceCraftTertiary016$1 = '#493408';
var colorReferenceCraftTertiary024$1 = '#6E4E0C';
var colorReferenceCraftTertiary032$1 = '#936710';
var colorReferenceCraftTertiary040$1 = '#B88114';
var colorReferenceCraftTertiary048$1 = '#DC9B18';
var colorReferenceCraftTertiary056$1 = '#E9AD35';
var colorReferenceCraftTertiary064$1 = '#EDBC5A';
var colorReferenceCraftTertiary072$1 = '#F1CB7E';
var colorReferenceCraftTertiary080$1 = '#F5DAA3';
var colorReferenceCraftTertiary088$1 = '#F9E9C8';
var colorReferenceCraftTertiary096$1 = '#FDF8ED';
var colorRoleBrand$1 = '#EB0033';
var colorRoleOnBrand$1 = '#FFFFFF';
var colorRoleBrandSecondary$1 = '#FFC2CF';
var colorRoleOnBrandSecondary$1 = '#FFFFFF';
var colorRoleInformative$1 = '#3664BF';
var colorRoleOnInformative$1 = '#FFFFFF';
var colorRoleInformativeSecondary$1 = '#CFDBF2';
var colorRoleOnInformativeSecondary$1 = '#122140';
var colorRoleSuccess$1 = '#4AAA85';
var colorRoleOnSuccess$1 = '#FFFFFF';
var colorRoleSuccessSecondary$1 = '#D4ECE3';
var colorRoleOnSuccessSecondary$1 = '#19392C';
var colorRoleCritical$1 = '#E01524';
var colorRoleOnCritical$1 = '#FFFFFF';
var colorRoleCriticalSecondary$1 = '#FAC7CB';
var colorRoleOnCriticalSecondary$1 = '#4B070C';
var colorRoleAttention$1 = '#E79F0D';
var colorRoleOnAttention$1 = '#141414';
var colorRoleAttentionSecondary$1 = '#FCE9C5';
var colorRoleOnAttentionSecondary$1 = '#4D3504';
var colorRoleBackground$1 = '#FFFFFF';
var colorRoleOnBackground$1 = '#141414';
var colorRoleBackgroundInverse$1 = '#141414';
var colorRoleOnBackgroundInverse$1 = '#FFFFFF';
var colorRoleBackgroundSecondary$1 = '#F5F5F5';
var colorRoleOnBackgroundSecondary$1 = '#141414';
var colorRoleBackgroundSecondaryInverse$1 = '#292929';
var colorRoleOnBackgroundSecondaryInverse$1 = '#FFFFFF';
var colorRoleSurface$1 = '#FFFFFF';
var colorRoleSurfaceInverse$1 = '#141414';
var colorRoleOnSurface$1 = '#141414';
var colorRoleOnSurfaceInverse$1 = '#FFFFFF';
var colorRoleSurfaceSecondary$1 = '#FFEBEF';
var colorRoleOnSurfaceSecondary$1 = '#141414';
var colorRoleSurfaceSecondaryInverse$1 = '#4B070C';
var colorRoleOnSurfaceSecondaryInverse$1 = '#FFFFFF';
var colorRoleOutline$1 = '#CCCCCC';
var colorRoleOutlineFocus$1 = '#141414';
var colorRoleHeading$1 = '#141414';
var colorRoleHeadingInverse$1 = '#FFFFFF';
var colorRoleBody$1 = '#525252';
var colorRoleBodyInverse$1 = '#CCCCCC';
var colorRoleBodySecondary$1 = '#7A7A7A';
var colorRoleBodySecondaryInverse$1 = '#A3A3A3';
var colorRoleHyperlink$1 = '#141414';

var lightThemeColor = {
  __proto__: null,
  colorReferenceBrand016: colorReferenceBrand016$1,
  colorReferenceBrand024: colorReferenceBrand024$1,
  colorReferenceBrand032: colorReferenceBrand032$1,
  colorReferenceBrand040: colorReferenceBrand040$1,
  colorReferenceBrand048: colorReferenceBrand048$1,
  colorReferenceBrand056: colorReferenceBrand056$1,
  colorReferenceBrand064: colorReferenceBrand064$1,
  colorReferenceBrand072: colorReferenceBrand072$1,
  colorReferenceBrand080: colorReferenceBrand080$1,
  colorReferenceBrand088: colorReferenceBrand088$1,
  colorReferenceBrand096: colorReferenceBrand096$1,
  colorReferenceInformative016: colorReferenceInformative016$1,
  colorReferenceInformative024: colorReferenceInformative024$1,
  colorReferenceInformative032: colorReferenceInformative032$1,
  colorReferenceInformative040: colorReferenceInformative040$1,
  colorReferenceInformative048: colorReferenceInformative048$1,
  colorReferenceInformative056: colorReferenceInformative056$1,
  colorReferenceInformative064: colorReferenceInformative064$1,
  colorReferenceInformative072: colorReferenceInformative072$1,
  colorReferenceInformative080: colorReferenceInformative080$1,
  colorReferenceInformative088: colorReferenceInformative088$1,
  colorReferenceInformative096: colorReferenceInformative096$1,
  colorReferenceSuccess016: colorReferenceSuccess016$1,
  colorReferenceSuccess024: colorReferenceSuccess024$1,
  colorReferenceSuccess032: colorReferenceSuccess032$1,
  colorReferenceSuccess040: colorReferenceSuccess040$1,
  colorReferenceSuccess048: colorReferenceSuccess048$1,
  colorReferenceSuccess056: colorReferenceSuccess056$1,
  colorReferenceSuccess064: colorReferenceSuccess064$1,
  colorReferenceSuccess072: colorReferenceSuccess072$1,
  colorReferenceSuccess080: colorReferenceSuccess080$1,
  colorReferenceSuccess088: colorReferenceSuccess088$1,
  colorReferenceSuccess096: colorReferenceSuccess096$1,
  colorReferenceCritical016: colorReferenceCritical016$1,
  colorReferenceCritical024: colorReferenceCritical024$1,
  colorReferenceCritical032: colorReferenceCritical032$1,
  colorReferenceCritical040: colorReferenceCritical040$1,
  colorReferenceCritical048: colorReferenceCritical048$1,
  colorReferenceCritical056: colorReferenceCritical056$1,
  colorReferenceCritical064: colorReferenceCritical064$1,
  colorReferenceCritical072: colorReferenceCritical072$1,
  colorReferenceCritical080: colorReferenceCritical080$1,
  colorReferenceCritical088: colorReferenceCritical088$1,
  colorReferenceCritical096: colorReferenceCritical096$1,
  colorReferenceAttention016: colorReferenceAttention016$1,
  colorReferenceAttention024: colorReferenceAttention024$1,
  colorReferenceAttention032: colorReferenceAttention032$1,
  colorReferenceAttention040: colorReferenceAttention040$1,
  colorReferenceAttention048: colorReferenceAttention048$1,
  colorReferenceAttention056: colorReferenceAttention056$1,
  colorReferenceAttention064: colorReferenceAttention064$1,
  colorReferenceAttention072: colorReferenceAttention072$1,
  colorReferenceAttention080: colorReferenceAttention080$1,
  colorReferenceAttention088: colorReferenceAttention088$1,
  colorReferenceAttention096: colorReferenceAttention096$1,
  colorReferenceNeutral100: colorReferenceNeutral100$1,
  colorReferenceNeutral008: colorReferenceNeutral008$1,
  colorReferenceNeutral016: colorReferenceNeutral016$1,
  colorReferenceNeutral024: colorReferenceNeutral024$1,
  colorReferenceNeutral032: colorReferenceNeutral032$1,
  colorReferenceNeutral040: colorReferenceNeutral040$1,
  colorReferenceNeutral048: colorReferenceNeutral048$1,
  colorReferenceNeutral056: colorReferenceNeutral056$1,
  colorReferenceNeutral064: colorReferenceNeutral064$1,
  colorReferenceNeutral072: colorReferenceNeutral072$1,
  colorReferenceNeutral080: colorReferenceNeutral080$1,
  colorReferenceNeutral088: colorReferenceNeutral088$1,
  colorReferenceNeutral096: colorReferenceNeutral096$1,
  colorReferenceCraftSecondary016: colorReferenceCraftSecondary016$1,
  colorReferenceCraftSecondary024: colorReferenceCraftSecondary024$1,
  colorReferenceCraftSecondary032: colorReferenceCraftSecondary032$1,
  colorReferenceCraftSecondary040: colorReferenceCraftSecondary040$1,
  colorReferenceCraftSecondary048: colorReferenceCraftSecondary048$1,
  colorReferenceCraftSecondary056: colorReferenceCraftSecondary056$1,
  colorReferenceCraftSecondary064: colorReferenceCraftSecondary064$1,
  colorReferenceCraftSecondary072: colorReferenceCraftSecondary072$1,
  colorReferenceCraftSecondary080: colorReferenceCraftSecondary080$1,
  colorReferenceCraftSecondary088: colorReferenceCraftSecondary088$1,
  colorReferenceCraftSecondary096: colorReferenceCraftSecondary096$1,
  colorReferenceCraftTertiary016: colorReferenceCraftTertiary016$1,
  colorReferenceCraftTertiary024: colorReferenceCraftTertiary024$1,
  colorReferenceCraftTertiary032: colorReferenceCraftTertiary032$1,
  colorReferenceCraftTertiary040: colorReferenceCraftTertiary040$1,
  colorReferenceCraftTertiary048: colorReferenceCraftTertiary048$1,
  colorReferenceCraftTertiary056: colorReferenceCraftTertiary056$1,
  colorReferenceCraftTertiary064: colorReferenceCraftTertiary064$1,
  colorReferenceCraftTertiary072: colorReferenceCraftTertiary072$1,
  colorReferenceCraftTertiary080: colorReferenceCraftTertiary080$1,
  colorReferenceCraftTertiary088: colorReferenceCraftTertiary088$1,
  colorReferenceCraftTertiary096: colorReferenceCraftTertiary096$1,
  colorRoleBrand: colorRoleBrand$1,
  colorRoleOnBrand: colorRoleOnBrand$1,
  colorRoleBrandSecondary: colorRoleBrandSecondary$1,
  colorRoleOnBrandSecondary: colorRoleOnBrandSecondary$1,
  colorRoleInformative: colorRoleInformative$1,
  colorRoleOnInformative: colorRoleOnInformative$1,
  colorRoleInformativeSecondary: colorRoleInformativeSecondary$1,
  colorRoleOnInformativeSecondary: colorRoleOnInformativeSecondary$1,
  colorRoleSuccess: colorRoleSuccess$1,
  colorRoleOnSuccess: colorRoleOnSuccess$1,
  colorRoleSuccessSecondary: colorRoleSuccessSecondary$1,
  colorRoleOnSuccessSecondary: colorRoleOnSuccessSecondary$1,
  colorRoleCritical: colorRoleCritical$1,
  colorRoleOnCritical: colorRoleOnCritical$1,
  colorRoleCriticalSecondary: colorRoleCriticalSecondary$1,
  colorRoleOnCriticalSecondary: colorRoleOnCriticalSecondary$1,
  colorRoleAttention: colorRoleAttention$1,
  colorRoleOnAttention: colorRoleOnAttention$1,
  colorRoleAttentionSecondary: colorRoleAttentionSecondary$1,
  colorRoleOnAttentionSecondary: colorRoleOnAttentionSecondary$1,
  colorRoleBackground: colorRoleBackground$1,
  colorRoleOnBackground: colorRoleOnBackground$1,
  colorRoleBackgroundInverse: colorRoleBackgroundInverse$1,
  colorRoleOnBackgroundInverse: colorRoleOnBackgroundInverse$1,
  colorRoleBackgroundSecondary: colorRoleBackgroundSecondary$1,
  colorRoleOnBackgroundSecondary: colorRoleOnBackgroundSecondary$1,
  colorRoleBackgroundSecondaryInverse: colorRoleBackgroundSecondaryInverse$1,
  colorRoleOnBackgroundSecondaryInverse: colorRoleOnBackgroundSecondaryInverse$1,
  colorRoleSurface: colorRoleSurface$1,
  colorRoleSurfaceInverse: colorRoleSurfaceInverse$1,
  colorRoleOnSurface: colorRoleOnSurface$1,
  colorRoleOnSurfaceInverse: colorRoleOnSurfaceInverse$1,
  colorRoleSurfaceSecondary: colorRoleSurfaceSecondary$1,
  colorRoleOnSurfaceSecondary: colorRoleOnSurfaceSecondary$1,
  colorRoleSurfaceSecondaryInverse: colorRoleSurfaceSecondaryInverse$1,
  colorRoleOnSurfaceSecondaryInverse: colorRoleOnSurfaceSecondaryInverse$1,
  colorRoleOutline: colorRoleOutline$1,
  colorRoleOutlineFocus: colorRoleOutlineFocus$1,
  colorRoleHeading: colorRoleHeading$1,
  colorRoleHeadingInverse: colorRoleHeadingInverse$1,
  colorRoleBody: colorRoleBody$1,
  colorRoleBodyInverse: colorRoleBodyInverse$1,
  colorRoleBodySecondary: colorRoleBodySecondary$1,
  colorRoleBodySecondaryInverse: colorRoleBodySecondaryInverse$1,
  colorRoleHyperlink: colorRoleHyperlink$1
};

/**
 * Do not edit this file directly
 * Generated by the Style Dictionary Builder.
 */
var component$1 = {
  badge: {
    root: {
      fontFamily: '"iFood RC Textos", Helvetica, Arial, sans-serif',
      fontWeight: '700',
      lineHeight: '16px',
      maxWidth: '200px',
      transitionDelay: '0ms',
      transitionDuration: '100ms',
      transitionTimingFunction: 'ease-in-out'
    },
    sm: {
      fontSize: '10px',
      height: '16px',
      minWidth: '16px',
      padding: '0px'
    },
    md: {
      fontSize: '12px',
      height: '24px',
      minWidth: '24px',
      padding: '4px'
    },
    standard: {
      backgroundColor: '#E0E0E0',
      color: '#141414'
    },
    active: {
      backgroundColor: '#3D3D3D',
      color: '#FFFFFF'
    },
    success: {
      backgroundColor: '#4AAA85',
      color: '#FFFFFF'
    },
    attention: {
      backgroundColor: '#E79F0D',
      color: '#141414'
    },
    critical: {
      backgroundColor: '#E01524',
      color: '#FFFFFF'
    },
    informative: {
      backgroundColor: '#3664BF',
      color: '#FFFFFF'
    },
    disabled: {
      backgroundColor: '#B8B8B8',
      color: '#7A7A7A'
    },
    pill: {
      borderRadius: '9999px'
    },
    semiSquare: {
      borderRadius: '2px'
    }
  },
  breadcrumbs: {
    root: {
      minHeight: '24px',
      minWidth: '120px'
    },
    list: {
      columnGap: '4px',
      margin: '0px',
      padding: '0px'
    }
  },
  button: {
    root: {
      borderWidth: '0px',
      boxShadow: '0px 0px 0px 0px rgba(0, 0, 0, 0.16)',
      fontSize: '16px',
      fontWeight: '700',
      lineHeight: '24px',
      minHeight: '40px',
      minWidth: '48px',
      transitionDelay: '0ms',
      transitionDuration: '100ms',
      transitionTimingFunction: 'ease-in-out',
      zIndex: '0'
    },
    rootBefore: {
      zIndex: '0'
    },
    rootAfter: {
      zIndex: '10'
    },
    content: {
      columnGap: '8px',
      lineHeight: '24px',
      minHeight: '24px',
      minWidth: '24px',
      zIndex: '50'
    },
    gutters: {
      paddingLeft: '24px',
      paddingRight: '24px'
    },
    primary: {
      boxShadow: '0px 0px 0px 0px rgba(0, 0, 0, 0.16)',
      color: '#FFFFFF'
    },
    primaryBefore: {
      backgroundColor: '#141414'
    },
    primaryDisabled: {
      boxShadow: '0px 0px 0px 0px rgba(0, 0, 0, 0.16)',
      color: '#A3A3A3'
    },
    primaryDisabledBefore: {
      backgroundColor: '#666666'
    },
    primaryFocused: {
      boxShadow: '0px 0px 0px 0px rgba(0, 0, 0, 0.16)',
      color: '#FFFFFF'
    },
    primaryFocusedBefore: {
      backgroundColor: '#3D3D3D'
    },
    primaryFocusedAfter: {
      backgroundColor: '#3D3D3D',
      opacity: '0'
    },
    primaryHover: {
      boxShadow: '0px 2px 8px 0px rgba(0, 0, 0, 0.16)',
      color: '#FFFFFF'
    },
    primaryHoverBefore: {
      backgroundColor: '#3D3D3D'
    },
    primaryHoverAfter: {
      backgroundColor: '#3D3D3D',
      opacity: '0'
    },
    primaryPressed: {
      boxShadow: '0px 0px 0px 0px rgba(0, 0, 0, 0.16)',
      color: '#FFFFFF'
    },
    primaryPressedBefore: {
      backgroundColor: '#292929'
    },
    primaryPressedAfter: {
      backgroundColor: 'rgba(224, 224, 224, 0.08)'
    },
    secondary: {
      boxShadow: '0px 0px 0px 0px rgba(0, 0, 0, 0.16)',
      color: '#141414'
    },
    secondaryBefore: {
      backgroundColor: '#F5F5F5'
    },
    secondaryDisabled: {
      boxShadow: '0px 0px 0px 0px rgba(0, 0, 0, 0.16)',
      color: '#7A7A7A'
    },
    secondaryDisabledBefore: {
      backgroundColor: '#B8B8B8'
    },
    secondaryFocused: {
      boxShadow: '0px 0px 0px 0px rgba(0, 0, 0, 0.16)',
      color: '#141414'
    },
    secondaryFocusedBefore: {
      backgroundColor: '#E0E0E0'
    },
    secondaryFocusedAfter: {
      backgroundColor: '#E0E0E0',
      opacity: '0'
    },
    secondaryHover: {
      boxShadow: '0px 2px 8px 0px rgba(0, 0, 0, 0.16)',
      color: '#141414'
    },
    secondaryHoverBefore: {
      backgroundColor: '#E0E0E0'
    },
    secondaryHoverAfter: {
      backgroundColor: '#E0E0E0',
      opacity: '0'
    },
    secondaryPressed: {
      boxShadow: '0px 0px 0px 0px rgba(0, 0, 0, 0.16)',
      color: '#141414'
    },
    secondaryPressedBefore: {
      backgroundColor: '#CCCCCC'
    },
    secondaryPressedAfter: {
      backgroundColor: '#CCCCCC',
      opacity: '0'
    },
    tertiary: {
      boxShadow: '0px 0px 0px 0px rgba(0, 0, 0, 0.16)',
      color: '#141414'
    },
    tertiaryBefore: {
      backgroundColor: 'rgba(255, 255, 255, 0)'
    },
    tertiaryDisabled: {
      boxShadow: '0px 0px 0px 0px rgba(0, 0, 0, 0.16)',
      color: '#7A7A7A'
    },
    tertiaryDisabledBefore: {
      backgroundColor: '#B8B8B8'
    },
    tertiaryFocused: {
      boxShadow: '0px 0px 0px 0px rgba(0, 0, 0, 0.16)',
      color: '#141414'
    },
    tertiaryFocusedBefore: {
      backgroundColor: '#F5F5F5'
    },
    tertiaryFocusedAfter: {
      backgroundColor: 'rgba(61, 61, 61, 0.08)'
    },
    tertiaryHover: {
      boxShadow: '0px 2px 8px 0px rgba(0, 0, 0, 0.16)',
      color: '#141414'
    },
    tertiaryHoverBefore: {
      backgroundColor: '#F5F5F5'
    },
    tertiaryHoverAfter: {
      backgroundColor: 'rgba(61, 61, 61, 0.08)'
    },
    tertiaryPressed: {
      boxShadow: '0px 0px 0px 0px rgba(0, 0, 0, 0.16)',
      color: '#141414'
    },
    tertiaryPressedBefore: {
      backgroundColor: '#E0E0E0'
    },
    tertiaryPressedAfter: {
      backgroundColor: 'rgba(61, 61, 61, 0.08)'
    },
    pill: {
      borderRadius: '9999px'
    },
    rounded: {
      borderRadius: '4px'
    },
    xs: {
      height: '32px'
    },
    sm: {
      height: '40px',
      paddingBottom: '8px',
      paddingTop: '8px'
    },
    md: {
      height: '48px',
      paddingBottom: '12px',
      paddingTop: '12px'
    },
    lg: {
      height: '56px',
      paddingBottom: '16px',
      paddingTop: '16px'
    },
    withStartIcon: {
      paddingLeft: '16px'
    }
  },
  buttonBase: {
    root: {
      borderRadius: '0px',
      borderWidth: '0px',
      fontFamily: '"iFood RC Textos", Helvetica, Arial, sans-serif',
      marginBottom: '0px',
      marginLeft: '0px',
      marginRight: '0px',
      marginTop: '0px',
      paddingBottom: '0px',
      paddingLeft: '0px',
      paddingRight: '0px',
      paddingTop: '0px',
      outlineColor: '#141414',
      outlineOffset: '0px',
      outlineWidth: '0px'
    },
    focusVisible: {
      outlineOffset: '2px',
      outlineWidth: '2px'
    }
  },
  buttonGroup: {
    spacingNone: {
      columnGap: '0px'
    },
    spacingXs: {
      columnGap: '20px'
    },
    spacingSm: {
      columnGap: '24px'
    }
  },
  calendar: {
    root: {
      backgroundColor: '#FFFFFF',
      borderColor: '#CCCCCC',
      borderRadius: '8px',
      borderWidth: '1px',
      color: '#141414',
      fontFamily: '"iFood RC Textos", Helvetica, Arial, sans-serif',
      fontSize: '16px',
      fontWeight: '500',
      lineHeight: '24px',
      top: '80px',
      zIndex: '10'
    },
    header: {
      backgroundColor: '#FFFFFF',
      color: '#141414',
      fontFamily: '"iFood RC Textos", Helvetica, Arial, sans-serif',
      fontSize: '16px',
      fontWeight: '500',
      lineHeight: '24px',
      paddingTop: '16px',
      paddingRight: '24px',
      paddingBottom: '16px',
      paddingLeft: '24px'
    },
    weekdays: {
      marginBottom: '8px'
    },
    cell: {
      backgroundColor: '#FFFFFF',
      color: '#141414',
      fontFamily: '"iFood RC Textos", Helvetica, Arial, sans-serif',
      fontSize: '16px',
      fontWeight: '400',
      gap: '8px',
      height: '24px',
      lineHeight: '24px',
      transitionDuration: '100ms',
      transitionTimingFunction: 'ease-in-out',
      width: '24px'
    },
    cellDisabled: {
      backgroundColor: '#FFFFFF',
      color: '#A6A6A6'
    },
    cellSelected: {
      backgroundColor: '#3664BF',
      color: '#FFFFFF'
    }
  },
  card: {
    root: {
      borderColor: '#CCCCCC',
      boxShadow: '0px 0px 0px 0px rgba(0, 0, 0, 0.16)',
      color: '#141414',
      fontFamily: '"iFood RC Textos", Helvetica, Arial, sans-serif',
      padding: '1px'
    },
    focusVisible: {
      borderColor: '#CCCCCC',
      outlineColor: '#141414',
      outlineOffset: '2px',
      outlineWidth: '2px'
    },
    hover: {
      backgroundColor: '#F5F5F5',
      borderColor: '#CCCCCC',
      boxShadow: '0px 0px 0px 0px rgba(0, 0, 0, 0.16)'
    },
    selected: {
      backgroundColor: '#FFFFFF',
      borderColor: '#141414',
      borderWidth: '2px',
      padding: '0px'
    },
    selectedHover: {
      backgroundColor: '#F5F5F5',
      borderColor: '#141414'
    },
    pressed: {
      backgroundColor: '#E0E0E0',
      borderColor: '#CCCCCC'
    },
    selectedFocusVisible: {
      borderColor: '#141414'
    },
    selectedPressed: {
      backgroundColor: '#E0E0E0',
      borderColor: '#141414'
    }
  },
  cardContent: {
    root: {
      fontWeight: '400',
      paddingBottom: '24px',
      paddingLeft: '24px',
      paddingRight: '24px',
      paddingTop: '24px',
      rowGap: '16px'
    },
    compact: {
      paddingBottom: '16px',
      paddingLeft: '16px',
      paddingRight: '16px',
      paddingTop: '16px'
    }
  },
  checkbox: {
    root: {
      color: '#CCCCCC',
      transitionDelay: '0ms',
      transitionDuration: '100ms',
      transitionTimingFunction: 'ease-in-out'
    },
    checked: {
      color: '#4AAA85'
    },
    indeterminate: {
      color: '#141414'
    },
    disabled: {
      color: '#7A7A7A'
    },
    disabledIndeterminate: {
      color: '#7A7A7A'
    }
  },
  chip: {
    root: {
      backgroundColor: '#F5F5F5',
      borderRadius: '9999px',
      columnGap: '8px',
      height: '32px',
      paddingBottom: '4px',
      paddingLeft: '16px',
      paddingRight: '16px',
      paddingTop: '4px'
    },
    withEndAdornment: {
      paddingRight: '4px'
    },
    withStartAdornment: {
      paddingLeft: '8px'
    }
  },
  container: {
    root: {
      paddingInlineEnd: '0px',
      paddingInlineStart: '0px'
    },
    sm: {
      minWidth: '320px'
    },
    md: {
      minWidth: '768px'
    },
    lg: {
      minWidth: '1140px'
    },
    xl: {
      minWidth: '1366px'
    },
    maxWidthSm: {
      maxWidth: '767px'
    },
    maxWidthMd: {
      maxWidth: '1139px'
    },
    maxWidthLg: {
      maxWidth: '1365px',
      minWidth: '1140px'
    },
    maxWidthXl: {
      maxWidth: '1366px',
      minWidth: '1366px'
    },
    maxWidthSidebarLayout: {
      maxWidth: '1718px'
    },
    looseSm: {
      paddingLeft: '24px',
      paddingRight: '24px'
    },
    tightSm: {
      paddingLeft: '48px',
      paddingRight: '48px'
    },
    looseMd: {
      paddingLeft: '32px',
      paddingRight: '32px'
    },
    tightMd: {
      paddingLeft: '48px',
      paddingRight: '48px'
    },
    looseLg: {
      paddingLeft: '48px',
      paddingRight: '48px'
    },
    tightLg: {
      paddingLeft: '120px',
      paddingRight: '120px'
    },
    looseXl: {
      paddingLeft: '64px',
      paddingRight: '64px'
    },
    tightXl: {
      paddingLeft: '160px',
      paddingRight: '160px'
    }
  },
  dialog: {
    surface: {
      color: '#525252',
      fontFamily: '"iFood RC Textos", Helvetica, Arial, sans-serif',
      minHeight: '80px',
      minWidth: '200px',
      outlineColor: '#141414',
      paddingBottom: '24px',
      paddingLeft: '24px',
      paddingRight: '24px',
      paddingTop: '32px',
      rowGap: '24px',
      zIndex: '300'
    },
    container: {
      zIndex: '250'
    },
    focused: {
      outlineWidth: '0px'
    },
    focusVisible: {
      outlineWidth: '0px'
    }
  },
  dialogActions: {
    root: {
      borderTopColor: '#CCCCCC',
      borderTopWidth: '1px',
      columnGap: '16px',
      marginBlockEnd: '0px',
      marginBlockStart: '0px',
      marginInlineEnd: '0px',
      marginInlineStart: '0px',
      marginTop: '24px',
      paddingInlineStart: '0px',
      paddingTop: '24px'
    }
  },
  dialogHeader: {
    root: {
      columnGap: '24px',
      minHeight: '24px',
      paddingBottom: '0px',
      paddingLeft: '0px',
      paddingRight: '0px',
      paddingTop: '0px'
    }
  },
  drawer: {
    surface: {
      zIndex: '300'
    },
    bottomAnchor: {
      borderBottomLeftRadius: '0px',
      borderBottomRightRadius: '0px',
      borderTopLeftRadius: '16px',
      borderTopRightRadius: '16px',
      boxShadow: '0px -16px 64px 0px rgba(0, 0, 0, 0.16)'
    },
    leftAnchor: {
      borderBottomLeftRadius: '0px',
      borderBottomRightRadius: '16px',
      borderTopLeftRadius: '0px',
      borderTopRightRadius: '16px',
      boxShadow: '16px 0px 64px 0px rgba(0, 0, 0, 0.16)'
    },
    rightAnchor: {
      borderBottomLeftRadius: '16px',
      borderBottomRightRadius: '0px',
      borderTopLeftRadius: '16px',
      borderTopRightRadius: '0px',
      boxShadow: '-16px 0px 64px 0px rgba(0, 0, 0, 0.16)'
    },
    topAnchor: {
      borderBottomLeftRadius: '16px',
      borderBottomRightRadius: '16px',
      borderTopLeftRadius: '0px',
      borderTopRightRadius: '0px',
      boxShadow: '0px 16px 64px 0px rgba(0, 0, 0, 0.16)'
    },
    container: {
      paddingLeft: '0px',
      paddingRight: '0px',
      zIndex: '250'
    }
  },
  fieldWrapper: {
    root: {
      borderWidth: '0px',
      margin: '0px',
      marginInlineEnd: '0px',
      marginInlineStart: '0px',
      padding: '0px',
      paddingBlockEnd: '0px',
      paddingBlockStart: '0px',
      paddingInlineEnd: '0px',
      paddingInlineStart: '0px',
      rowGap: '8px'
    }
  },
  formHelperText: {
    root: {
      transitionDuration: '100ms',
      transitionTimingFunction: 'ease-in-out',
      lineHeight: '24px'
    },
    error: {
      color: '#E01524'
    },
    focused: {
      color: '#122140'
    }
  },
  formLabel: {
    root: {
      minHeight: '24px'
    }
  },
  globalStyle: {
    body: {
      backgroundColor: '#FFFFFF',
      color: '#525252',
      fontFamily: '"iFood RC Textos", Helvetica, Arial, sans-serif',
      fontWeight: '400',
      marginBottom: '0px',
      marginLeft: '0px',
      marginRight: '0px',
      marginTop: '0px'
    },
    bodyBackdrop: {
      backgroundColor: '#FFFFFF'
    },
    bodyPrint: {
      backgroundColor: '#FFFFFF'
    },
    bold: {
      color: '500'
    },
    reducedMotion: {
      animationDuration: '0ms',
      transitionDuration: '0ms'
    },
    strong: {
      color: '500'
    }
  },
  gridContainer: {
    looseSm: {
      columnGap: '8px'
    },
    tightSm: {
      columnGap: '8px'
    },
    looseMd: {
      columnGap: '16px'
    },
    tightMd: {
      columnGap: '16px'
    },
    looseLg: {
      columnGap: '24px'
    },
    tightLg: {
      columnGap: '24px'
    },
    looseXl: {
      columnGap: '24px'
    },
    tightXl: {
      columnGap: '24px'
    }
  },
  header: {
    root: {
      minHeight: '64px',
      minWidth: '200px'
    },
    container: {
      columnGap: '8px',
      marginLeft: '0px',
      marginRight: '0px'
    },
    gutters: {
      marginLeft: '24px',
      marginRight: '8px'
    },
    guttersWithStartAdornment: {
      marginLeft: '8px'
    },
    content: {
      marginBottom: '24px',
      marginTop: '24px',
      minHeight: '24px',
      minWidth: '120px'
    },
    adornment: {
      columnGap: '8px',
      marginBottom: '12px',
      marginTop: '12px',
      minHeight: '48px',
      minWidth: '48px'
    }
  },
  hyperlink: {
    root: {
      borderWidth: '0px',
      color: '#141414'
    },
    hover: {
      color: '#525252'
    }
  },
  icon: {
    sm: {
      fontSize: '16px'
    },
    md: {
      fontSize: '24px'
    },
    lg: {
      fontSize: '32px'
    }
  },
  iconButton: {
    root: {
      borderRadius: '9999px',
      marginLeft: '0px',
      marginRight: '0px'
    },
    xs: {
      minHeight: '32px',
      minWidth: '32px',
      paddingBottom: '4px',
      paddingLeft: '4px',
      paddingRight: '4px',
      paddingTop: '4px'
    },
    sm: {
      minHeight: '40px',
      minWidth: '40px',
      paddingBottom: '8px',
      paddingLeft: '8px',
      paddingRight: '8px',
      paddingTop: '8px'
    },
    md: {
      minHeight: '48px',
      minWidth: '48px',
      paddingBottom: '12px',
      paddingLeft: '12px',
      paddingRight: '12px',
      paddingTop: '12px'
    },
    edgeStart: {
      marginLeft: '-8px',
      marginRight: '0px'
    },
    edgeEnd: {
      marginLeft: '0px',
      marginRight: '-8px'
    }
  },
  input: {
    root: {
      fontFamily: '"iFood RC Textos", Helvetica, Arial, sans-serif',
      fontSize: '16px',
      height: '56px',
      lineHeight: '24px',
      padding: '16px',
      zIndex: '0'
    },
    disabled: {
      backgroundColor: '#B8B8B8',
      borderColor: '{color.component.onBackground.disabled',
      color: '#7A7A7A'
    },
    error: {
      backgroundColor: '#FAC7CB',
      borderColor: '#E01524',
      borderWidth: '1px',
      color: '#4B070C'
    },
    focused: {
      backgroundColor: '#FFFFFF',
      borderColor: '#CCCCCC',
      borderWidth: '1px',
      color: '#141414',
      outlineColor: '#141414',
      outlineOffset: '2px',
      outlineWidth: '2px'
    },
    placeholder: '#7A7A7A'
  },
  inputAdornment: {
    positionStart: {
      marginLeft: '16px',
      marginRight: '0px'
    },
    positionEnd: {
      marginLeft: '16px',
      marginRight: '16px'
    }
  },
  inputLabel: {
    root: {
      color: '#141414',
      marginBottom: '0px',
      transitionDuration: '250ms',
      transitionTimingFunction: 'ease-in',
      zIndex: '0'
    },
    error: {
      color: '#E01524'
    },
    focused: {
      color: '#122140'
    }
  },
  list: {
    root: {
      marginBlockEnd: '0px',
      marginBlockStart: '0px',
      marginBottom: '0px',
      marginLeft: '0px',
      marginInlineEnd: '0px',
      marginInlineStart: '0px',
      marginRight: '0px',
      marginTop: '0px',
      paddingBottom: '0px',
      paddingInlineStart: '0px',
      paddingLeft: '0px',
      paddingRight: '0px',
      paddingTop: '0px'
    }
  },
  listItem: {
    root: {
      borderBottomColor: '#CCCCCC',
      borderBottomWidth: '1px',
      paddingLeft: '0px',
      paddingRight: '0px'
    },
    expanded: {
      paddingBottom: '32px',
      paddingTop: '32px'
    },
    compact: {
      paddingBottom: '24px',
      paddingTop: '24px'
    },
    last: {
      borderBottomWidth: '0px'
    }
  },
  listRow: {
    root: {
      color: '#525252',
      fontFamily: '"iFood RC Textos", Helvetica, Arial, sans-serif',
      fontSize: '14px',
      lineHeight: '24px',
      paddingTop: '20px',
      paddingRight: '0px',
      paddingBottom: '20px',
      paddingLeft: '0px',
      borderBottomColor: '#CCCCCC'
    }
  },
  menuItem: {
    root: {
      backgroundColor: '#FFFFFF',
      color: '#7A7A7A',
      fontWeight: '400',
      marginBottom: '0px',
      marginTop: '0px',
      minHeight: '48px',
      paddingBottom: '12px',
      paddingLeft: '16px',
      paddingRight: '16px',
      paddingTop: '12px',
      transitionDelay: '0ms',
      transitionDuration: '100ms',
      transitionTimingFunction: 'ease-in-out'
    },
    before: {
      backgroundColor: '#141414',
      borderBottomLeftRadius: '0px',
      borderBottomRightRadius: '4px',
      borderTopLeftRadius: '0px',
      borderTopRightRadius: '4px',
      height: '32px',
      opacity: '0',
      width: '2px'
    },
    focused: {
      backgroundColor: '#F5F5F5',
      color: '#141414',
      opacity: '1'
    },
    gutters: {
      paddingLeft: '24px',
      paddingRight: '24px'
    },
    hover: {
      backgroundColor: '#FFFFFF'
    },
    selected: {
      backgroundColor: '#F5F5F5',
      color: '#525252',
      fontWeight: '500'
    },
    selectedBefore: {
      opacity: '1'
    },
    selectedHover: {
      backgroundColor: '#F5F5F5'
    },
    selectedHoverNone: {
      backgroundColor: '#F5F5F5'
    }
  },
  menuItemIcon: {
    root: {
      height: '24px',
      marginRight: '16px',
      minHeight: '24px',
      minWidth: '24px',
      width: '24px'
    }
  },
  menuItemText: {
    root: {
      marginBottom: '0px',
      marginLeft: '0px',
      marginRight: '0px',
      marginTop: '0px',
      minWidth: '0px',
      transitionDelay: '0ms',
      transitionDuration: '50ms',
      transitionTimingFunction: 'ease-in-out'
    }
  },
  menuList: {
    root: {
      borderRadius: '0px',
      borderTopWidth: '0px',
      boxShadow: '0px 0px 0px 0px rgba(0, 0, 0, 0.16)'
    }
  },
  navBar: {
    root: {
      borderBottomColor: '#CCCCCC',
      borderBottomWidth: '1px',
      fontFamily: '"iFood RC Textos", Helvetica, Arial, sans-serif',
      margin: '0px',
      minHeight: '56px',
      zIndex: '100'
    },
    positionFixed: {
      zIndex: '99'
    },
    prominent: {
      minHeight: '80px',
      paddingBottom: '0px',
      paddingTop: '0px'
    },
    container: {
      minHeight: '48px'
    },
    maxWidthSidebarLayoutContainer: {
      paddingLeft: '32px',
      paddingRight: '32px'
    },
    prominentContainer: {
      paddingBottom: '16px',
      paddingTop: '16px'
    }
  },
  overlay: {
    root: {
      backgroundColor: 'rgba(0, 0, 0, 0.32)',
      opacity: '1',
      zIndex: '200'
    }
  },
  pageHeader: {
    heading: {
      marginBottom: '8px',
      marginTop: '0px'
    },
    text: {
      marginBottom: '0px',
      marginTop: '0px'
    }
  },
  pagination: {
    root: {
      fontFamily: '"iFood RC Textos", Helvetica, Arial, sans-serif',
      minHeight: '24px',
      minWidth: '24px'
    },
    list: {
      columnGap: '8px',
      margin: '0px',
      padding: '0px'
    },
    item: {
      color: '#141414'
    },
    disabledItem: {
      color: '#7A7A7A'
    },
    ellipsis: {
      color: '#141414'
    }
  },
  passwordInput: {
    toggle: {
      paddingTop: '4px',
      paddingRight: '4px',
      paddingBottom: '4px',
      paddingLeft: '4px'
    }
  },
  progressBar: {
    root: {
      backgroundColor: '#FFFFFF',
      borderRadius: '9999px',
      borderWidth: '0px',
      height: '4px',
      minWidth: '200px',
      zIndex: '0'
    },
    progressBar: {
      borderRadius: '9999px',
      height: '4px'
    },
    progressValue: {
      transitionDelay: '0ms',
      transitionDuration: '250ms',
      transitionTimingFunction: 'ease-in-out',
      zIndex: '10'
    },
    success: {
      backgroundColor: '#4AAA85'
    },
    informative: {
      backgroundColor: '#3664BF'
    },
    critical: {
      backgroundColor: '#E01524'
    },
    attention: {
      backgroundColor: '#E79F0D'
    }
  },
  select: {
    root: {
      borderWidth: '0px',
      fontFamily: '"iFood RC Textos", Helvetica, Arial, sans-serif',
      marginInlineEnd: '0px',
      marginInlineStart: '0px',
      minHeight: '56px',
      paddingBlockEnd: '0px',
      paddingBlockStart: '0px',
      paddingInlineEnd: '0px',
      paddingInlineStart: '0px'
    },
    control: {
      backgroundColor: '#FFFFFF',
      borderColor: '#CCCCCC',
      borderRadius: '2px',
      borderWidth: '1px',
      boxShadow: '0px 0px 0px 0px rgba(0, 0, 0, 0.16)',
      color: '#525252'
    },
    controlError: {
      backgroundColor: '#FAC7CB',
      borderColor: '#E01524',
      borderWidth: '1px',
      color: '#4B070C'
    },
    controlFocused: {
      borderColor: '#CCCCCC',
      outlineColor: '#141414',
      outlineOffset: '2px',
      outlineWidth: '2px'
    },
    controlHover: {
      borderColor: '#CCCCCC'
    },
    disabledControl: {
      backgroundColor: '#B8B8B8'
    },
    disabledIndicator: {
      color: '#7A7A7A'
    },
    indicator: {
      color: '#525252',
      paddingBottom: '16px',
      paddingLeft: '16px',
      paddingRight: '16px',
      paddingTop: '16px'
    },
    indicatorError: {
      color: '#4B070C'
    },
    menu: {
      borderBottomWidth: '1px',
      borderColor: '#CCCCCC',
      borderLeftWidth: '1px',
      borderRightWidth: '1px',
      zIndex: '50'
    },
    menuOption: {
      backgroundColor: '#FFFFFF',
      color: '#141414',
      paddingBottom: '16px',
      paddingLeft: '16px',
      paddingRight: '16px',
      paddingTop: '16px'
    },
    menuOptionSelected: {
      backgroundColor: '#141414',
      color: '#FFFFFF',
      opacity: '1'
    },
    placeholder: {
      color: '#7A7A7A',
      fontWeight: '400',
      fontSize: '16px',
      letterSpacing: '0px',
      lineHeight: '24px',
      marginBottom: '2px'
    },
    placeholderError: {
      color: '#4B070C'
    },
    singleValue: {
      color: '#141414'
    },
    inputContainer: {
      marginTop: '0px',
      marginRight: '0px',
      marginBottom: '0px',
      marginLeft: '0px'
    },
    valueContainer: {
      paddingTop: '16px',
      paddingRight: '16px',
      paddingBottom: '16px',
      paddingLeft: '16px'
    }
  },
  shape: {
    circle: {
      borderRadius: '100%'
    },
    ellipse: {
      borderRadius: '100%'
    },
    pill: {
      borderRadius: '9999px'
    },
    rectangle: {
      borderRadius: '0px'
    },
    square: {
      borderRadius: '0px'
    }
  },
  sidebar: {
    root: {
      backgroundColor: '#FFFFFF',
      zIndex: '10'
    }
  },
  sidebarLayout: {
    sidebar: {
      borderRightColor: '#CCCCCC',
      borderRightWidth: '1px'
    }
  },
  skeleton: {
    skeleton: {
      animationDelay: '400ms',
      animationTimingFunction: 'ease-in-out'
    }
  },
  storybook: {
    app: {
      backgroundColor: '#F5F5F5',
      borderColor: '#CCCCCC',
      borderRadius: '4px'
    },
    appContent: {
      backgroundColor: '#FFFFFF'
    },
    bar: {
      backgroundColor: '#F5F5F5',
      color: '#141414'
    },
    barSelected: {
      color: '#EB0033'
    },
    primary: {
      color: '#EB0033'
    },
    secondary: {
      color: '#141414'
    },
    text: {
      color: '#141414',
      fontFamily: '"iFood RC Textos", Helvetica, Arial, sans-serif'
    },
    textInverse: {
      color: '#FFFFFF'
    },
    input: {
      backgroundColor: '#FFFFFF',
      borderColor: '#CCCCCC',
      borderRadius: '2px',
      color: '#141414'
    }
  },
  surface: {
    root: {
      backgroundColor: '#FFFFFF',
      borderColor: '#CCCCCC',
      borderRadius: '0px',
      borderWidth: '0px',
      boxShadow: '0px 0px 0px 0px rgba(0, 0, 0, 0.16)',
      color: '#141414',
      transitionDelay: '0ms',
      transitionDuration: '100ms',
      transitionTimingFunction: 'ease-in-out'
    },
    outlined: {
      borderWidth: '1px'
    },
    shapeStylePill: {
      borderRadius: '9999px'
    },
    shapeStyleRounded: {
      borderRadius: '4px'
    },
    shapeStyleSemiSquare: {
      borderRadius: '2px'
    },
    shadowLowest: {
      boxShadow: '0px 2px 2px 0px rgba(0, 0, 0, 0.16)'
    },
    colorLowest: {
      backgroundColor: '#F5F5F5'
    }
  },
  tab: {
    root: {
      borderBottomColor: '#CCCCCC',
      borderBottomWidth: '1px',
      borderTopLeftRadius: '2px',
      borderTopRightRadius: '2px',
      color: '#7A7A7A',
      fontWeight: '400',
      height: '56px',
      minWidth: '80px',
      transitionDelay: '0ms',
      transitionDuration: '100ms',
      transitionTimingFunction: 'ease-in-out',
      zIndex: '0'
    },
    tabStatus: {
      maxWidth: '160px'
    },
    rootBefore: {
      backgroundColor: 'rgba(255, 255, 255, 0)',
      paddingLeft: '2px',
      zIndex: '0'
    },
    rootAfter: {
      paddingRight: '2px',
      zIndex: '10'
    },
    content: {
      borderRadius: '2px',
      marginBottom: '16px',
      height: '40px',
      paddingBottom: '8px',
      paddingTop: '8px',
      zIndex: '50'
    },
    standardContent: {
      paddingLeft: '16px',
      paddingRight: '16px'
    },
    compactContent: {
      paddingLeft: '8px',
      paddingRight: '8px'
    },
    hover: {
      color: '#525252'
    },
    hoverBefore: {
      backgroundColor: '#F5F5F5'
    },
    hoverAfter: {
      backgroundColor: 'rgba(61, 61, 61, 0.08)'
    },
    focusVisible: {
      borderBottomColor: 'rgba(255, 255, 255, 0)',
      borderBottomLeftRadius: '2px',
      borderBottomRightRadius: '2px',
      color: '#525252',
      outlineColor: '#141414',
      outlineOffset: '2px',
      outlineWidth: '2px'
    },
    focusVisibleBefore: {
      backgroundColor: '#F5F5F5'
    },
    focusVisibleAfter: {
      backgroundColor: 'rgba(61, 61, 61, 0.08)'
    },
    pressed: {
      color: '#525252'
    },
    pressedBefore: {
      backgroundColor: '#E0E0E0'
    },
    pressedAfter: {
      backgroundColor: 'rgba(61, 61, 61, 0.08)'
    },
    selected: {
      borderBottomColor: '#141414',
      color: '#141414',
      fontWeight: '700'
    },
    selectedBefore: {
      backgroundColor: '#F5F5F5'
    },
    selectedHover: {
      color: '#141414'
    },
    selectedHoverBefore: {
      backgroundColor: '#F5F5F5'
    },
    selectedHoverAfter: {
      backgroundColor: 'rgba(61, 61, 61, 0.08)'
    },
    selectedPressed: {
      color: '#141414'
    },
    selectedPressedBefore: {
      backgroundColor: '#E0E0E0'
    },
    selectedPressedAfter: {
      backgroundColor: 'rgba(61, 61, 61, 0.08)'
    },
    selectedFocusVisible: {
      color: '#141414'
    },
    disabled: {
      color: '#B8B8B8'
    },
    startAdornment: {
      marginLeft: '0px',
      marginRight: '8px'
    },
    endAdornment: {
      marginLeft: '8px',
      marginRight: '0px'
    }
  },
  tabBar: {
    root: {
      paddingBottom: '16px',
      paddingTop: '0px'
    },
    gutterTop: {
      paddingTop: '32px'
    },
    after: {
      borderBottomColor: '#CCCCCC',
      borderBottomWidth: '1px'
    }
  },
  table: {
    root: {
      borderSpacing: '8px',
      color: '#525252',
      fontFamily: '"iFood RC Textos", Helvetica, Arial, sans-serif',
      fontWeight: '400',
      fontSize: '14px',
      lineHeight: '24px'
    }
  },
  tableCell: {
    root: {
      backgroundColor: '#FFFFFF',
      paddingBottom: '8px',
      paddingLeft: '16px',
      paddingRight: '16px',
      paddingTop: '8px',
      height: '56px',
      minHeight: '56px'
    },
    checkboxPadding: {
      maxHeight: '48px',
      minHeight: '48px',
      minWidth: '40px',
      width: '48px'
    },
    densePadding: {
      height: '80px',
      minHeight: '80px'
    },
    head: {
      backgroundColor: '#F5F5F5',
      borderRadius: '4px'
    }
  },
  tableHead: {
    root: {
      backgroundColor: '#F5F5F5',
      color: '#141414',
      fontFamily: '"iFood RC Textos", Helvetica, Arial, sans-serif',
      fontWeight: '500'
    }
  },
  tableRow: {
    root: {
      outlineWidth: '0px'
    },
    hover: {
      backgroundColor: '#F5F5F5'
    },
    selected: {
      backgroundColor: '#F5F5F5'
    }
  },
  tabPanel: {
    root: {
      paddingTop: '24px'
    }
  },
  tooltip: {
    root: {
      animationDuration: '100ms',
      animationTimingFunction: 'ease-in-out',
      borderRadius: '4px',
      fontFamily: '"iFood RC Textos", Helvetica, Arial, sans-serif',
      fontSize: '12px',
      lineHeight: '16px',
      paddingBottom: '8px',
      paddingLeft: '8px',
      paddingRight: '8px',
      paddingTop: '8px',
      transitionDuration: '100ms',
      transitionTimingFunction: 'ease-in-out',
      zIndex: '500'
    },
    arrowBottom: {
      left: '4px'
    },
    arrowBottomLeft: {
      right: '8px'
    },
    arrowBottomRight: {
      left: '8px'
    },
    arrowLeft: {
      right: '16px'
    },
    arrowRight: {
      left: '16px'
    },
    arrowTop: {
      left: '4px'
    },
    arrowTopLeft: {
      right: '8px'
    },
    arrowTopRight: {
      left: '8px'
    },
    'arrow-attention': {
      fill: '#E79F0D'
    },
    'arrow-critical': {
      fill: '#E01524'
    },
    'arrow-default': {
      fill: '#4B070C'
    },
    'arrow-informative': {
      fill: '#3664BF'
    },
    'arrow-success': {
      fill: '#4AAA85'
    },
    attention: {
      color: '#141414',
      backgroundColor: '#E79F0D'
    },
    critical: {
      color: '#FFFFFF',
      backgroundColor: '#E01524'
    },
    containerBottom: {
      top: '16px'
    },
    containerBottomLeft: {
      top: '16px',
      right: '24px'
    },
    containerBottomRight: {
      top: '16px',
      left: '24px'
    },
    containerLeft: {
      right: '16px'
    },
    containerRight: {
      left: '16px'
    },
    containerTop: {
      bottom: '16px'
    },
    containerTopLeft: {
      bottom: '16px',
      right: '24px'
    },
    containerTopRight: {
      bottom: '16px',
      left: '24px'
    },
    "default": {
      color: '#FFFFFF',
      backgroundColor: '#4B070C'
    },
    hidden: {
      opacity: '0'
    },
    informative: {
      color: '#FFFFFF',
      backgroundColor: '#3664BF'
    },
    success: {
      color: '#FFFFFF',
      backgroundColor: '#4AAA85'
    },
    shown: {
      opacity: '1'
    }
  },
  typography: {
    root: {
      marginBlockEnd: '0px',
      marginBlockStart: '0px',
      marginBottom: '0px',
      marginLeft: '0px',
      marginInlineEnd: '0px',
      marginInlineStart: '0px',
      marginRight: '0px',
      marginTop: '0px'
    },
    display: {
      color: '#141414',
      fontFamily: '"iFood RC Textos", Helvetica, Arial, sans-serif',
      fontWeight: '400',
      letterSpacing: '-2px'
    },
    displayDesktop: {
      fontSize: '48px',
      fontWeight: '400',
      letterSpacing: '-2px',
      lineHeight: '56px'
    },
    displayDesktopGutterBottom: {
      marginBottom: '48px'
    },
    displayMobile: {
      fontSize: '40px',
      fontWeight: '400',
      letterSpacing: '-2px',
      lineHeight: '48px'
    },
    displayMobileGutterBottom: {
      marginBottom: '40px'
    },
    heading1: {
      color: '#141414',
      fontFamily: '"iFood RC Textos", Helvetica, Arial, sans-serif'
    },
    heading1Desktop: {
      fontSize: '40px',
      fontWeight: '400',
      letterSpacing: '-2px',
      lineHeight: '48px'
    },
    heading1DesktopGutterBottom: {
      marginBottom: '40px'
    },
    heading1Mobile: {
      fontSize: '32px',
      fontWeight: '500',
      letterSpacing: '-1px',
      lineHeight: '40px'
    },
    heading1MobileGutterBottom: {
      marginBottom: '32px'
    },
    heading2: {
      color: '#141414',
      fontFamily: '"iFood RC Textos", Helvetica, Arial, sans-serif'
    },
    heading2Desktop: {
      fontSize: '32px',
      fontWeight: '500',
      letterSpacing: '-1px',
      lineHeight: '40px'
    },
    heading2DesktopGutterBottom: {
      marginBottom: '32px'
    },
    heading2Mobile: {
      fontSize: '24px',
      fontWeight: '500',
      letterSpacing: '-1px',
      lineHeight: '32px'
    },
    heading2MobileGutterBottom: {
      marginBottom: '24px'
    },
    heading3: {
      color: '#141414',
      fontFamily: '"iFood RC Textos", Helvetica, Arial, sans-serif'
    },
    heading3Desktop: {
      fontSize: '24px',
      fontWeight: '500',
      letterSpacing: '-1px',
      lineHeight: '32px'
    },
    heading3DesktopGutterBottom: {
      marginBottom: '24px'
    },
    heading3Mobile: {
      fontSize: '20px',
      fontWeight: '500',
      letterSpacing: '-1px',
      lineHeight: '24px'
    },
    heading3MobileGutterBottom: {
      marginBottom: '16px'
    },
    heading4: {
      color: '#141414',
      fontFamily: '"iFood RC Textos", Helvetica, Arial, sans-serif'
    },
    heading4Desktop: {
      fontSize: '20px',
      fontWeight: '500',
      letterSpacing: '-1px',
      lineHeight: '24px'
    },
    heading4DesktopGutterBottom: {
      marginBottom: '16px'
    },
    heading4Mobile: {
      fontSize: '16px',
      fontWeight: '500',
      letterSpacing: '-1px',
      lineHeight: '16px'
    },
    heading4MobileGutterBottom: {
      marginBottom: '8px'
    },
    body1: {
      color: '#525252',
      fontFamily: '"iFood RC Textos", Helvetica, Arial, sans-serif',
      letterSpacing: '0px'
    },
    body1Desktop: {
      fontSize: '16px',
      lineHeight: '24px'
    },
    body1DesktopGutterBottom: {
      marginBottom: '40px'
    },
    body1Mobile: {
      fontSize: '16px',
      lineHeight: '24px'
    },
    body1MobileGutterBottom: {
      marginBottom: '40px'
    },
    body2: {
      color: '#525252',
      fontFamily: '"iFood RC Textos", Helvetica, Arial, sans-serif',
      letterSpacing: '0px'
    },
    body2Desktop: {
      fontSize: '14px',
      lineHeight: '24px'
    },
    body2DesktopGutterBottom: {
      marginBottom: '40px'
    },
    body2Mobile: {
      fontSize: '14px',
      lineHeight: '24px'
    },
    body2MobileGutterBottom: {
      marginBottom: '40px'
    },
    body3: {
      color: '#525252',
      fontFamily: '"iFood RC Textos", Helvetica, Arial, sans-serif',
      letterSpacing: '0px'
    },
    body3Desktop: {
      fontSize: '12px',
      lineHeight: '16px'
    },
    body3DesktopGutterBottom: {
      marginBottom: '40px'
    },
    body3Mobile: {
      fontSize: '12px',
      lineHeight: '16px'
    },
    body3MobileGutterBottom: {
      marginBottom: '40px'
    },
    regular: {
      fontWeight: '400'
    },
    medium: {
      fontWeight: '500'
    },
    bold: {
      fontWeight: '700'
    }
  }
};

/**
 * Do not edit this file directly
 * Generated by the Style Dictionary Builder.
 */
var motionDurationInstantly = '0ms';
var motionDurationImmediately = '50ms';
var motionDurationQuickly = '100ms';
var motionDurationPromptly = '250ms';
var motionDurationSlowly = '400ms';
var motionTimingFunctionsEase = 'ease';
var motionTimingFunctionsEaseIn = 'ease-in';
var motionTimingFunctionsEaseInOut = 'ease-in-out';

var motion = {
  __proto__: null,
  motionDurationInstantly: motionDurationInstantly,
  motionDurationImmediately: motionDurationImmediately,
  motionDurationQuickly: motionDurationQuickly,
  motionDurationPromptly: motionDurationPromptly,
  motionDurationSlowly: motionDurationSlowly,
  motionTimingFunctionsEase: motionTimingFunctionsEase,
  motionTimingFunctionsEaseIn: motionTimingFunctionsEaseIn,
  motionTimingFunctionsEaseInOut: motionTimingFunctionsEaseInOut
};

/**
 * @deprecated Please use `sizingScale200`
 */
var size7xl = '200px';
/**
 * @deprecated Please use `sizingScale160`
 */

var size6xl = '160px';
/**
 * @deprecated Please use `sizingScale120`
 */

var size5xl = '120px';
/**
 * @deprecated Please use `sizingScale80`
 */

var size4xl = '80px';
/**
 * @deprecated Please use `sizingScale64`
 */

var size3xl = '64px';
/**
 * @deprecated Please use `sizingScale56`
 */

var size2xl = '56px';
/**
 * @deprecated Please use `sizingScale48`
 */

var sizeXl = '48px';
/**
 * @deprecated Please use `sizingScale40`
 */

var sizeLg = '40px';
/**
 * @deprecated Please use `sizingScale32`
 */

var sizeMd = '32px';
/**
 * @deprecated Please use `sizingScale24`
 */

var sizeSm = '24px';
/**
 * @deprecated Please use `sizingScale20`
 */

var sizeXs = '20px';
/**
 * @deprecated Please use `sizingScale16`
 */

var size2xs = '16px';
/**
 * @deprecated Please use `sizingScale12`
 */

var size3xs = '12px';
/**
 * @deprecated Please use `sizingScale8`
 */

var size4xs = '8px';
/**
 * @deprecated Please use `sizingScale4`
 */

var size5xs = '4px';
/**
 * @deprecated Please use `sizingScale2`
 */

var size6xs = '2px';
/**
 * @deprecated Please use `sizingNone`
 */

var sizeNone = '0px';

var size = {
  __proto__: null,
  size7xl: size7xl,
  size6xl: size6xl,
  size5xl: size5xl,
  size4xl: size4xl,
  size3xl: size3xl,
  size2xl: size2xl,
  sizeXl: sizeXl,
  sizeLg: sizeLg,
  sizeMd: sizeMd,
  sizeSm: sizeSm,
  sizeXs: sizeXs,
  size2xs: size2xs,
  size3xs: size3xs,
  size4xs: size4xs,
  size5xs: size5xs,
  size6xs: size6xs,
  sizeNone: sizeNone
};

/**
 * Do not edit this file directly
 * Generated by the Style Dictionary Builder.
 */
var sizingNone = '0px';
var sizingScale2 = '2px';
var sizingScale4 = '4px';
var sizingScale8 = '8px';
var sizingScale12 = '12px';
var sizingScale16 = '16px';
var sizingScale20 = '20px';
var sizingScale24 = '24px';
var sizingScale32 = '32px';
var sizingScale40 = '40px';
var sizingScale48 = '48px';
var sizingScale56 = '56px';
var sizingScale64 = '64px';
var sizingScale80 = '80px';
var sizingScale120 = '120px';
var sizingScale160 = '160px';
var sizingScale200 = '200px';

var sizing = {
  __proto__: null,
  sizingNone: sizingNone,
  sizingScale2: sizingScale2,
  sizingScale4: sizingScale4,
  sizingScale8: sizingScale8,
  sizingScale12: sizingScale12,
  sizingScale16: sizingScale16,
  sizingScale20: sizingScale20,
  sizingScale24: sizingScale24,
  sizingScale32: sizingScale32,
  sizingScale40: sizingScale40,
  sizingScale48: sizingScale48,
  sizingScale56: sizingScale56,
  sizingScale64: sizingScale64,
  sizingScale80: sizingScale80,
  sizingScale120: sizingScale120,
  sizingScale160: sizingScale160,
  sizingScale200: sizingScale200
};

/**
 * Do not edit this file directly
 * Generated by the Style Dictionary Builder.
 */
var spacingNone = '0px';
var spacingScale2 = '2px';
var spacingScale4 = '4px';
var spacingScale8 = '8px';
var spacingScale12 = '12px';
var spacingScale16 = '16px';
var spacingScale20 = '20px';
var spacingScale24 = '24px';
var spacingScale32 = '32px';
var spacingScale40 = '40px';
var spacingScale48 = '48px';
var spacingScale56 = '56px';
var spacingScale64 = '64px';
var spacingScale80 = '80px';
var spacingScale120 = '120px';
var spacingScale160 = '160px';
var spacingScale200 = '200px';
var spacingInsetScale2 = '2px';
var spacingInsetScale4 = '4px';
var spacingInsetScale8 = '8px';
var spacingInsetScale12 = '12px';
var spacingInsetScale16 = '16px';
var spacingInsetScale20 = '20px';
var spacingInsetScale24 = '24px';
var spacingInsetScale32 = '32px';
var spacingInsetScale40 = '40px';

var currentSpacing = {
  __proto__: null,
  spacingNone: spacingNone,
  spacingScale2: spacingScale2,
  spacingScale4: spacingScale4,
  spacingScale8: spacingScale8,
  spacingScale12: spacingScale12,
  spacingScale16: spacingScale16,
  spacingScale20: spacingScale20,
  spacingScale24: spacingScale24,
  spacingScale32: spacingScale32,
  spacingScale40: spacingScale40,
  spacingScale48: spacingScale48,
  spacingScale56: spacingScale56,
  spacingScale64: spacingScale64,
  spacingScale80: spacingScale80,
  spacingScale120: spacingScale120,
  spacingScale160: spacingScale160,
  spacingScale200: spacingScale200,
  spacingInsetScale2: spacingInsetScale2,
  spacingInsetScale4: spacingInsetScale4,
  spacingInsetScale8: spacingInsetScale8,
  spacingInsetScale12: spacingInsetScale12,
  spacingInsetScale16: spacingInsetScale16,
  spacingInsetScale20: spacingInsetScale20,
  spacingInsetScale24: spacingInsetScale24,
  spacingInsetScale32: spacingInsetScale32,
  spacingInsetScale40: spacingInsetScale40
};

/**
 * @deprecated Please use `spacingInsetScale2HorizontalSpacing`
 */
var spacingInset6xsHorizontalSpacing = '2px';
/**
 * @deprecated Please use `spacingInsetScale2VerticalSpacing`
 */

var spacingInset6xsVerticalSpacing = '2px';
/**
 * @deprecated Please use `spacingInsetScale4HorizontalSpacing`
 */

var spacingInset5xsHorizontalSpacing = '4px';
/**
 * @deprecated Please use `spacingInsetScale4VerticalSpacing`
 */

var spacingInset5xsVerticalSpacing = '4px';
/**
 * @deprecated Please use `spacingInsetScale8HorizontalSpacing`
 */

var spacingInset4xsHorizontalSpacing = '8px';
/**
 * @deprecated Please use `spacingInsetScale8VerticalSpacing`
 */

var spacingInset4xsVerticalSpacing = '8px';
/**
 * @deprecated Please use `spacingInsetScale12HorizontalSpacing`
 */

var spacingInset3xsHorizontalSpacing = '12px';
/**
 * @deprecated Please use `spacingInsetScale12VerticalSpacing`
 */

var spacingInset3xsVerticalSpacing = '12px';
/**
 * @deprecated Please use `spacingInsetScale16HorizontalSpacing`
 */

var spacingInset2xsHorizontalSpacing = '16px';
/**
 * @deprecated Please use `spacingInsetScale16VerticalSpacing`
 */

var spacingInset2xsVerticalSpacing = '16px';
/**
 * @deprecated Please use `spacingInsetScale20HorizontalSpacing`
 */

var spacingInsetXsHorizontalSpacing = '20px';
/**
 * @deprecated Please use `spacingInsetScale20VerticalSpacing`
 */

var spacingInsetXsVerticalSpacing = '20px';
/**
 * @deprecated Please use `spacingInsetScale24HorizontalSpacing`
 */

var spacingInsetSmHorizontalSpacing = '24px';
/**
 * @deprecated Please use `spacingInsetScale24VerticalSpacing`
 */

var spacingInsetSmVerticalSpacing = '24px';
/**
 * @deprecated Please use `spacingInsetScale32HorizontalSpacing`
 */

var spacingInsetMdHorizontalSpacing = '32px';
/**
 * @deprecated Please use `spacingInsetScale32VerticalSpacing`
 */

var spacingInsetMdVerticalSpacing = '32px';
/**
 * @deprecated Please use `spacingInsetScale40HorizontalSpacing`
 */

var spacingInsetLgHorizontalSpacing = '40px';
/**
 * @deprecated Please use `spacingInsetScale40VerticalSpacing`
 */

var spacingInsetLgVerticalSpacing = '40px';
/**
 * @deprecated Please use `spacingScale200`
 */

var spacing7xl = '200px';
/**
 * @deprecated Please use `spacingScale160`
 */

var spacing6xl = '160px';
/**
 * @deprecated Please use `spacingScale120`
 */

var spacing5xl = '120px';
/**
 * @deprecated Please use `spacingScale80`
 */

var spacing4xl = '80px';
/**
 * @deprecated Please use `spacingScale64`
 */

var spacing3xl = '64px';
/**
 * @deprecated Please use `spacingScale56`
 */

var spacing2xl = '56px';
/**
 * @deprecated Please use `spacingScale48`
 */

var spacingXl = '48px';
/**
 * @deprecated Please use `spacingScale40`
 */

var spacingLg = '40px';
/**
 * @deprecated Please use `spacingScale32`
 */

var spacingMd = '32px';
/**
 * @deprecated Please use `spacingScale24`
 */

var spacingSm = '24px';
/**
 * @deprecated Please use `spacingScale20`
 */

var spacingXs = '20px';
/**
 * @deprecated Please use `spacingScale16`
 */

var spacing2xs = '16px';
/**
 * @deprecated Please use `spacingScale12`
 */

var spacing3xs = '12px';
/**
 * @deprecated Please use `spacingScale8`
 */

var spacing4xs = '8px';
/**
 * @deprecated Please use `spacingScale4`
 */

var spacing5xs = '4px';
/**
 * @deprecated Please use `spacingScale2`
 */

var spacing6xs = '2px';

var legacySpacing = {
  __proto__: null,
  spacingInset6xsHorizontalSpacing: spacingInset6xsHorizontalSpacing,
  spacingInset6xsVerticalSpacing: spacingInset6xsVerticalSpacing,
  spacingInset5xsHorizontalSpacing: spacingInset5xsHorizontalSpacing,
  spacingInset5xsVerticalSpacing: spacingInset5xsVerticalSpacing,
  spacingInset4xsHorizontalSpacing: spacingInset4xsHorizontalSpacing,
  spacingInset4xsVerticalSpacing: spacingInset4xsVerticalSpacing,
  spacingInset3xsHorizontalSpacing: spacingInset3xsHorizontalSpacing,
  spacingInset3xsVerticalSpacing: spacingInset3xsVerticalSpacing,
  spacingInset2xsHorizontalSpacing: spacingInset2xsHorizontalSpacing,
  spacingInset2xsVerticalSpacing: spacingInset2xsVerticalSpacing,
  spacingInsetXsHorizontalSpacing: spacingInsetXsHorizontalSpacing,
  spacingInsetXsVerticalSpacing: spacingInsetXsVerticalSpacing,
  spacingInsetSmHorizontalSpacing: spacingInsetSmHorizontalSpacing,
  spacingInsetSmVerticalSpacing: spacingInsetSmVerticalSpacing,
  spacingInsetMdHorizontalSpacing: spacingInsetMdHorizontalSpacing,
  spacingInsetMdVerticalSpacing: spacingInsetMdVerticalSpacing,
  spacingInsetLgHorizontalSpacing: spacingInsetLgHorizontalSpacing,
  spacingInsetLgVerticalSpacing: spacingInsetLgVerticalSpacing,
  spacing7xl: spacing7xl,
  spacing6xl: spacing6xl,
  spacing5xl: spacing5xl,
  spacing4xl: spacing4xl,
  spacing3xl: spacing3xl,
  spacing2xl: spacing2xl,
  spacingXl: spacingXl,
  spacingLg: spacingLg,
  spacingMd: spacingMd,
  spacingSm: spacingSm,
  spacingXs: spacingXs,
  spacing2xs: spacing2xs,
  spacing3xs: spacing3xs,
  spacing4xs: spacing4xs,
  spacing5xs: spacing5xs,
  spacing6xs: spacing6xs
};

var spacing = /*#__PURE__*/_extends({}, legacySpacing, currentSpacing);

var base = {
  breakpoint: breakpoint,
  motion: motion,
  size: size,
  spacing: spacing,
  sizing: sizing,
  border: border,
  lineHeight: lineHeight,
  typography: {
    family: fontFamily,
    size: fontSize,
    weight: fontWeight
  }
};

var dark = /*#__PURE__*/_extends({}, base, {
  color: darkThemeColor,
  colorScheme: 'dark',
  component: component
});

var light = /*#__PURE__*/_extends({}, base, {
  color: lightThemeColor,
  colorScheme: 'light',
  component: component$1
});

var defaultTheme = {
  dark: dark,
  light: light
};

export { defaultTheme };
//# sourceMappingURL=fits-themes.esm.js.map
